import { ErrorResponse, FarmTypesEnum, GlobalStatus, GlobalVariableValues, HarvestTypes, MessageParameters, MessageRequest, OperationTypeEnum, SaleOrderStatusEnum, ShrimpTypeEnum, SoStatusEnum, StatusEnum, SupplierType, SupplierTypeEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import { AllGrnResponseModel, GrnDetailsDto, GrnDetailViewModel, GrnDetailViewResponseModel, grnItemsDataModel, grnQtyDto, GrnQtyResponseModel, PoVendorDataModel, GrnReturnAutoFillDto, GrnReturnAutoFillModel, GrnNumberResponseModel, GrnNumberDto, GrnItemReceivedQtyResponse, PoNumbersModel, AllGrnDto, AllGrnReportResponse, AllGrnReportDto, GrnDetailsForReturn, GrnItemsForReturn, GrnItemReturnResponse, GrnInspectionreq, grnIdreq, grnReportreq, grnReportreqsponse, grnInspectionData, QuantityDeviationRequest, GrnItemIdRequest, BatchNumRequest, LotNumRequest, RmCountRequest, RmReceivingReportReq, RmReceivingDataModel, RmReceivingReportModel, GrnIDRequest, getMonthWisePurchaseRequest, RmRatesReportReq } from '@gtpl/shared-models/procurement-management';
import { forwardRef, Inject, Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Not, Repository } from 'typeorm';
import { PurchaseOrderIdRequest } from '../po-creation/dto/po-id.request';
import { ItemCategoryService, ItemsService, ItemSubCategoryService, SizesService, TaxesService, UnitcodeService, VendorsPriceListService, VendorsService } from '@gtpl/shared-services/masters'
import { GrnQtyRequest } from './dto/grn-qty-request';
import { GrnIdRequest } from './dto/grn-request';
import { grnResponse } from './dto/grn-response';
import { GrnAdapter } from './dto/grn.adapter';
import { GrnDto } from './dto/grn.dto';
import { GrnItems } from './grn-items.entity';
import { Grn } from './grn.entity';
import { Cron } from '@nestjs/schedule';
import { GrnRepository } from './repository/grn-repository';
import { CommonResponse, InvoiceStatusEnum, ItemCategoryReq, ItemRequest, ItemSubCategoryRequest, SizeRequest, SizesDropDownDto, UnitTypeEnum, VendorItemRequest } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { PoItems } from '../po-creation/po-creation-items.entity';
import { PoItemsRepository } from '../po-creation/repository/po-items.repository';
import { GrnItemReceivedQtyRequest } from './dto/grn-item-received-qty-request';
import { isEmpty, Matches } from 'class-validator';
import { Stock } from '../stock/stock.entity';
import { StockDto } from '../stock/dto/stock.dto';
import { StockAdapter } from '../stock/dto/stock.adapter';
import { PoRepository } from '../po-creation/repository/po-repository';
import { StockRepository } from './repository/stock-repository';
// import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { BomUpdateRequest, CountRequest, SoRequest } from '@gtpl/shared-models/sale-management';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { PurchaseOrderService } from '@gtpl/shared-services/procurement';
import { PoRequest } from "@gtpl/shared-models/procurement-management";
import { PoCreationService } from '../po-creation/po-creation.service';
import { IsNull } from 'typeorm';
import { GrnReportRequest } from './grn-report-request';
import appSettings from 'apps/services/config';
import Link from 'antd/lib/typography/Link';
import { StockService } from '../stock/stock.service';
import { WhatsAppNotificationService } from '@gtpl/shared-services/notification-management';
import { whatsApp } from '../../../../../services/whatsapp'
import { SaleOrderIdRequest } from '@gtpl/shared-models/warehouse-management';
import { WhatsappBroadCastService } from '@gtpl/shared-services/whatsapp-broad-cast'
import { Result, Tag } from 'antd';
import { ArrowDownOutlined } from '@ant-design/icons';
import { link } from 'fs';
import { error } from 'console';
import { BroadCastMessageRequest, WhatsAppLogDto } from '@gtpl/shared-models/whatsapp-broad-cast';
import { invoiceNumberRequest } from './dto/invoice-number-req';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { AssetService } from '@gtpl/shared-services/asset-management';
import { AssetDto } from "libs/shared-models/asset-management/src/lib/open-assets/assets.dto";
import { isNull } from 'util';
import { GrnInspection } from './grn-inspection-enity';
import { InspectedGrnInfoModel } from '@gtpl/shared-models/finance'
import { CommonResponse as Response } from '@gtpl/shared-models/sale-management';
import { CompanyCategoryEnum, PayablesDashboardReq } from '@gtpl/shared-models/raw-material-procurement';
import { FileUploadResponse } from 'libs/shared-models/logistics/src/lib/container-log-book/file-upload.response';
import { IdRequest } from '@gtpl/shared-models/gtpl';
import dayjs from 'dayjs'

let moment = require('moment')
const grnTable = appSettings.procure_db + '.grn';
const poTable = appSettings.procure_db + '.purchase_order';
const poItemsTable = appSettings.procure_db + '.purchase_order_items';
const soTable = appSettings.sales_db + '.sale_order';
const soInvTable = appSettings.sales_db + '.so_invoice_details';
const vendorsTable = appSettings.masters_db + '.vendors';


@Injectable()
export class GrnService {
  constructor(
    private logService: LogsService,

    @InjectRepository(Grn)
    private grnRepository: Repository<Grn>,

    @InjectRepository(PoItems)
    private poItemsRepository: Repository<PoItems>,
    // @InjectRepository(Stock)
    private stockRepo: StockRepository,
    @InjectRepository(GrnItems)
    private GrnItemsRepository: Repository<GrnItems>,
    private grnAdapter: GrnAdapter,
    private stockAdapter: StockAdapter,
    private itemCategoryService: ItemCategoryService,
    private itemService: ItemsService,
    private grnRepo: GrnRepository,
    private sizeService: SizesService,
    private stockService: StockService,
    private soService: SaleOrderService,

    private wpService: WhatsAppNotificationService,
    // private poRepo: PoRepository,
    private vendorService: VendorsService,
    // @InjectRepository(PoItemsRepository)
    private poItemRepo: PoItemsRepository,
    private saleService: SaleOrderService,
    private vendorPriceListService: VendorsPriceListService,
    // private poService: PurchaseOrderService,
    // @Inject(forwardRef(() => PoCreationService))
    private poService: PoCreationService,
    private taxService: TaxesService,
    private subCategoryService: ItemSubCategoryService,
    private wtsAppBroadCatService: WhatsappBroadCastService,
    private assetService: AssetService,

    @InjectRepository(GrnInspection)
    private grnInspectionRepo: Repository<GrnInspection>,

  ) { }

  async createGrn(grnDto: GrnDto, isUpdate: boolean): Promise<grnResponse> {
    const manager = new GenericTransactionManager();
    console.log(grnDto, 'grnDtokk')
    const queryManager = getManager();

    try {
      let count;
      let today = new Date();
      let CurrentYear = today.getFullYear();
      let CurrentMonth = today.getMonth();
      let toDate = 0;
      let finYear = '';
      if (!isUpdate) {
        if (CurrentMonth < 4) {
          toDate = (CurrentYear);
        } else {
          toDate = (CurrentYear + 1);
        }
        finYear = toDate.toString().substr(-2)
        let grnInfo = this.grnRepo
          .createQueryBuilder('Grn')
          .select([
            'max(Grn.grn_id) as MaxGrnId'
          ])

        const grnData = await grnInfo.getRawOne();
        count = grnData.MaxGrnId
        count = count + 1;
        var refNo = count + "";
        while (refNo.length < 4) refNo = "0" + refNo;
        const grnEntity = await this.getGrnById(grnDto.grnId);
        if (grnEntity) {
          throw new ErrorResponse(11104, 'Grn already exists');
        }
      }
      const vendorItemMap = new Map<Number, Map<Number, Number>>();
      let vendorPriceStatus = true;
      for (const grnItem of grnDto.grnItemsInfo) {
        console.log(grnItem, 'grnItem')
        const vendorItemReq = new VendorItemRequest(grnDto.vendorId, grnItem.itemId);
        const vedorPriceData = await this.vendorPriceListService.GetItemPriceTaxForVendorIdItemId(vendorItemReq);
        if (vedorPriceData.status) {
          if (!(vendorItemMap.has(grnDto.vendorId))) {
            vendorItemMap.set(grnDto.vendorId, new Map<Number, number>());
            if (!(vendorItemMap.get(grnDto.vendorId).has(grnItem.itemId))) {
              vendorItemMap
                .get(grnDto.vendorId)
                .set(grnItem.itemId, vedorPriceData.data.unitPrice);
            }
          } else {
            if (!(vendorItemMap.get(grnDto.vendorId).has(grnItem.itemId))) {
              vendorItemMap
                .get(grnDto.vendorId)
                .set(grnItem.itemId, vedorPriceData.data.unitPrice);
            }
          }
        } else {
          vendorPriceStatus = false;
        }
      }
      const grnNumber = 'GRN/' + finYear + '/' + refNo;

      let invoiceDate = dayjs(grnDto.InvoiceDate).toDate(); 
      let year = invoiceDate.getFullYear()
      let month = invoiceDate.getMonth()
      let fromYear
      let toYear
      if ((Number(month) + 1) < 4) {
        fromYear = (year - 1);
        toYear = (year);
      } else {
        fromYear = (year);
        toYear = (year + 1);
      }

      let tdsFlag 

      let amountInfo
      const getTdsApplicableInfoQry = `SELECT * from ${appSettings.procure_db} .grn_items gi LEFT JOIN ${appSettings.procure_db} .grn g ON g.grn_id = gi.grn_id 
      WHERE tds_applicable = 1 AND g.vendor_id = ${grnDto.vendorId} AND Date(invoice_date) BETWEEN '${fromYear}-04-01' AND '${toYear}-03-31'`
      const tdsApplicableInfo = await queryManager.query(getTdsApplicableInfoQry)

      if(tdsApplicableInfo.length > 0){
        tdsFlag = true
      }else{
        tdsFlag = false
        const amountAgainstvendorQry = `SELECT SUM((gi.received_quantity * gi.unit_price) - gi.discount_amount) as amount FROM ${appSettings.procure_db} .grn_items gi LEFT JOIN ${appSettings.procure_db} .grn g ON g.grn_id = gi.grn_id WHERE  g.vendor_id = ${grnDto.vendorId} AND Date(invoice_date) BETWEEN '${fromYear}-04-01' AND '${toYear}-03-31' `
        amountInfo = await queryManager.query(amountAgainstvendorQry)
      }
      const convertedGrnEntity: Grn = this.grnAdapter.convertDtoToEntity(grnDto, isUpdate, count, vendorPriceStatus, vendorItemMap, grnNumber,tdsFlag,tdsFlag ? 0 : amountInfo[0].amount);


      // console.log(convertedGrnEntity);
      await manager.startTransaction();

      //saving into GRN and GRN Items
      const savedEntity: Grn = await manager.getRepository(Grn).save(convertedGrnEntity);
      const savedGrnDto: GrnDto = this.grnAdapter.convertEntityToDto(savedEntity);
      for (const grnItemRecord of grnDto.grnItemsInfo) {
        //asset saving if GRN item is an asset
        if (grnItemRecord.isAsset == GlobalStatus.YES) {
          console.log('saveresultyess', grnItemRecord.isAsset)
          for (let i = 0; i < grnItemRecord.acceptedQuantity; i++) {
            //asset code need autgenerate
            const assetDto = new AssetDto(null, grnItemRecord.itemId, 'asset code', null, grnItemRecord.itemId, savedGrnDto.grnId, grnItemRecord.acceptedQuantity, null, null, null, null, null, null, grnDto.invoiceNumber, null, grnItemRecord.unitPrice, grnDto.grnDate, 'Asset', 'GRN', null, 'No', null, null, null, 1, null, null, null, null, null, null, null, null, null, grnDto.createdUser, true, undefined)
            console.log(assetDto, 'assetDtoggg')
            const assetObjSave = await this.assetService.createAssets(assetDto)
            if (!assetObjSave.status) {
              await manager.releaseTransaction();
              throw new ErrorResponse(1111, 'Something went wrong in Asset creation')
            }
            console.log('saveresult', assetObjSave)
          }
        }
      }


      let itemcategoryId
      // let bulkStockId = 0
      for (const grnItem of savedGrnDto.grnItemsInfo) {
        const itemData = grnItem.itemId
        if (grnItem.saleOrderId > 0) {
          let isManuallyAddedItem
          const bomData = await this.soService.getBomDataById(new SaleOrderIdRequest(grnItem.saleOrderId, undefined, grnItem.itemId, '', ''));
          console.log(bomData)
          if (bomData.data.status) {
            const packCat = bomData.data.data.packingCategory;
            if (packCat != 'Added In PO') {
              const updatePackingBOMGRN = await this.soService.updatePackingBOMGRNData(new BomUpdateRequest(grnItem.itemId, grnItem.saleOrderId, grnItem.acceptedQuantity, undefined));
              if (!updatePackingBOMGRN.status) {
                throw new ErrorResponse(1111, 'Something went wrong in packing BOM log  updation')
              }
            }
          } else {
            throw new ErrorResponse(1111, 'Something went wrong in getting BOM')
          }
        }
        if (grnItem.itemCategoryId == 33) {
          const existingStock = await manager.getCustomRepository(StockRepository).find({ where: { itemId: grnItem.itemId, unitId: grnDto.unitId, saleOrderId: 0, locationId: GlobalVariableValues.generalStoreLocation } })

          const stockObj = new Stock()
          stockObj.createdUser = grnItem.createdUser
          stockObj.itemCategoryId = grnItem.itemCategoryId
          stockObj.itemId = grnItem.itemId
          stockObj.itemSubCategoryId = grnItem.itemSubCategoryId
          stockObj.saleOrderId = 0
          stockObj.locationId = GlobalVariableValues.generalStoreLocation
          stockObj.unitId = grnDto.unitId,
            stockObj.unitPrice = grnDto.unitId,
            stockObj.sizeId = grnItem.unitPrice
          if (existingStock.length > 0) {
            stockObj.stockId = existingStock[0].stockId
          stockObj.physicalQuantity = Number(existingStock[0].physicalQuantity)  + Number(grnItem.acceptedQuantity)
          }else{
            stockObj.physicalQuantity = grnItem.acceptedQuantity

          }
          const saveStock = await manager.getCustomRepository(StockRepository).save(stockObj)
          if (!saveStock) {
            throw new ErrorResponse(1111, 'Something went wrong in Inventory Update')
          }
        }
        //   let stockData
        //   let toBeMovedBulkQty
        //   let BulkstockData
        //   let existingStockId
        //   let existingStockQty
        //   let toBeMoved = false
        //   let soStatus = SaleOrderStatusEnum.OPEN;
        //   let stockAcceptedQty
        //   let isTotalMoved = false
        //   let isOnlyInsert = false
        //   let isInsertAndInsert = false
        //   let stockBulkAcceptedQty

        //   //check weathre saleorder cancelled or not
        //   const soStatusInfo = await this.saleService.getSoStatusBySoId({ saleOrderId: grnItem.saleOrderId });
        //   const bomStatusInfo = await this.saleService.getBomDataById({ saleOrderId: grnItem.saleOrderId, plantId: null, itemId: grnItem.itemId })
        //   // console.log('bomStatusInfo');
        //   // console.log(bomStatusInfo);
        //   if (bomStatusInfo.data.status) {
        //     // console.log('one')
        //     const existedstockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //     // console.log('existedstockData')
        //     // console.log(existedstockData)
        //     // console.log(bomStatusInfo.data.data.isRequired)

        //     // if(existedstockData){
        //       if (existedstockData && bomStatusInfo.data.data.isRequired == GlobalStatus.NO || (bomStatusInfo.data.data.isRequired == GlobalStatus.YES && bomStatusInfo.data.data.isQtyRevised == GlobalStatus.YES && existedstockData && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(grnItem.acceptedQuantity))))) {
        //       console.log('two')

        //         toBeMovedBulkQty = (Number(grnItem.acceptedQuantity)) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
        //         toBeMoved = true
        //         if (bomStatusInfo.data.data.quantity <= Number(existedstockData.physicalQuantity)) {
        //           isOnlyInsert = true
        //           stockAcceptedQty = grnItem.acceptedQuantity
        //         }
        //         if (bomStatusInfo.data.data.quantity > Number(existedstockData.physicalQuantity) && (Number(bomStatusInfo.data.data.quantity) < (Number(existedstockData.physicalQuantity) + Number(grnItem.acceptedQuantity)))) {
        //           isInsertAndInsert = true
        //           stockAcceptedQty = (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
        //           stockBulkAcceptedQty = Number(grnItem.acceptedQuantity) - (bomStatusInfo.data.data.quantity - Number(existedstockData.physicalQuantity))
        //         }


        //       } else {
        //       console.log('three')

        //         if (soStatusInfo.data.status) {
        //       console.log('four')

        //           stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //           soStatus = SaleOrderStatusEnum.CANCELLED;
        //           stockAcceptedQty = grnItem.acceptedQuantity
        //         } else {
        //       console.log('five')

        //           stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //           stockAcceptedQty = grnItem.acceptedQuantity
        //         }
        //       }
        //     // }

        //   } else {
        //     console.log('five')

        //     stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //     stockAcceptedQty = grnItem.acceptedQuantity
        //   }
        //   if (toBeMoved) {
        //     console.log('six')

        //     stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //     if (isInsertAndInsert) {
        //       // stockData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: grnItem.saleOrderId, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //       const bulkExistingData = await this.stockRepo.findOne({ select: ['stockId', 'physicalQuantity'], where: { saleOrderId: 0, itemId: grnItem.itemId, unitId: grnDto.unitId, locationId: (grnDto.locationId > 0 ? grnDto.locationId : 0) } })
        //       if (bulkExistingData) {
        //         bulkStockId = bulkExistingData.stockId;
        //         const stockUpdate = await manager.getCustomRepository(StockRepository).update({ saleOrderId: 0, itemId: grnItem.itemId }, { physicalQuantity: () =>physical_quantity+${toBeMovedBulkQty}` })
        //         if (!stockUpdate.affected) {
        //           throw new ErrorResponse(1111, 'Something went wrong in stock updation')
        //         }
        //       } else {
        //         const convertedBulkStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItem, existingStockId, existingStockQty, grnDto.locationId, savedGrnDto.unitId, soStatus, stockBulkAcceptedQty, isInsertAndInsert, isOnlyInsert);
        //         const savedBulkStockEntity: Stock = await manager.getRepository(Stock).save(convertedBulkStockEntity);
        //         if (savedBulkStockEntity) {
        //           bulkStockId = savedBulkStockEntity.stockId;
        //         }
        //         if (!savedBulkStockEntity) {
        //           throw new ErrorResponse(111, 'something went wrong in bulk stock insertion')
        //         }
        //       }
        //     }
        //   }


        //   //check weather the request Item is new or existed against Sale order

        //   if (stockData) {
        //     existingStockId = stockData.stockId;
        //     existingStockQty = stockData.physicalQuantity;

        //   }
        itemcategoryId = grnItem.itemCategoryId;

        //   //saved grn items addition into stock 
        //   // if(stockCheckCount > 0){
        //   // const stockUpdate = await this.stockRepository.update({purchaseOrderId:poId,itemName:itemId},{ receivedQuantity: updatedRecQty} )
        //   // }else{

        //   const convertedStockEntity: Stock = this.stockAdapter.convertDtoToEntity(grnItem, existingStockId, existingStockQty, grnDto.locationId, savedGrnDto.unitId, soStatus, stockAcceptedQty, isInsertAndInsert, isOnlyInsert);
        //   // }

        //   const savedStockEntity: Stock = await manager.getRepository(Stock).save(convertedStockEntity);
        //   const savedStockDto: StockDto = this.stockAdapter.convertEntityToDto(savedStockEntity);
        //   if(!savedStockEntity){
        //     throw new ErrorResponse(111, 'something went wrong in stock saving')
        //   }


        //   //mapping GRn with stock
        //   const itemStockMapUpdate = await manager.getRepository(GrnItems).update({ grnItemId: grnItem.grnItemId }, { stockId: savedStockDto.stockId, bulkStockId: bulkStockId })
        //   if(!itemStockMapUpdate){
        //     throw new ErrorResponse(111, 'something went wrong in stock and Grn mapping')
        //   }


        //Received GRN Qty updation against PO
        const recQty = await manager.getRepository(PoItems).findOne({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: grnItem.poId, itemCategory: grnItem.itemCategoryId, itemName: grnItem.itemId, saleOrderId: grnItem.saleOrderId } })
        const poItemsUpdate = await this.poItemRepo.updateReceivedQty(recQty.receivedQuantity, grnItem.acceptedQuantity, grnItem.itemId, grnItem.poId, grnItem.saleOrderId, grnItem.itemCategoryId, manager)


        if (grnItem.saleOrderId) {
          const bulkstockDetails = await this.stockService.getInventoryStockQty({
            saleOrderId: undefined, itemCategoryId: grnItem.itemCategoryId, itemId: grnItem.itemId
          }
          );
          let existingQty = 0;
          if (bulkstockDetails.status) {
            if (bulkstockDetails.data.physicalQuantity > 0) {
              existingQty = bulkstockDetails.data.physicalQuantity;
            }
          }
          //received qty updation in BOM against saleorder and item
          const bomItemUpdate: boolean = await this.saleService.updateBomQty(new BomUpdateRequest(grnItem.itemId, grnItem.saleOrderId, grnItem.acceptedQuantity, existingQty))

          if (!bomItemUpdate) {
            throw new ErrorResponse(11106, 'Something went wrong in updation of BOM Received Quantity');

          }

          //updation of 
          const soTrackUpdate = await this.saleService.updateSoTrackPmStatus(new SoRequest(grnItem.saleOrderId, itemcategoryId))

          const latestUpdatedQty = Number(recQty.receivedQuantity) + Number(grnItem.acceptedQuantity);
        }

        // if(latestUpdatedQty == recQty.itemQuantity){

        // }



      }

      const poItemsdata = await manager.getRepository(PoItems).find({ select: ['receivedQuantity', 'itemQuantity'], where: { purchaseOrderId: grnDto.poId, isActive: true } })
      const qtyFlagSet = new Set<boolean>();

      for (const poItem of poItemsdata) {

        if (Number(poItem.receivedQuantity) >= Number(poItem.itemQuantity)) {
          qtyFlagSet.add(true)
        } else {
          qtyFlagSet.add(false)
        }
      }
      let statusVal = StatusEnum.IN_PROGRESS;
      if (!(qtyFlagSet.has(false))) {
        statusVal = StatusEnum.CLOSED;
      }
      const existingPodata = await manager.getCustomRepository(PoRepository).findOne({ purchaseOrderId: grnDto.poId })
      let maxGrnDate = grnDto.grnDate
      if (existingPodata) {
        if (existingPodata.maxGrnDate == null || existingPodata.maxGrnDate < grnDto.grnDate) {
          maxGrnDate = grnDto.grnDate
        }
      }
      const poStatusUpdate = await manager.getCustomRepository(PoRepository).update({ purchaseOrderId: grnDto.poId }, { status: statusVal, maxGrnDate: maxGrnDate });
      if (!poStatusUpdate) {
        throw new ErrorResponse(11106, 'Something went wrong in status updation');
      }



      await manager.completeTransaction();


      // const grnQtyForPo = await this.grnRepo.getGrnQtyForPo(savedGrnDto.poId)

      if (savedEntity) {

        if (savedGrnDto) {
          const conManager = getManager();
          let query = "select SUM(item_quantity) from " + appSettings.procure_db + ".purchase_order_items poi left join " + appSettings.procure_db + ".purchase_order po on po.purchase_order_id = poi.purchase_order_id where poi.purchase_order_id =" + savedGrnDto.poId + " group by poi.sale_order_id order by poi.sale_order_id";
          let queryResult = await conManager.query(query);
          console.log("queryResult" + queryResult);

          let grnCount = "Select g.vendor_id AS vendorId,v.vendor_name AS vendorName,soi.po_number AS soNo,it.item_name AS item,SUM(po_quantity) AS poQuantity, SUM(accepted_quantity) AS acceptedQuantity, (((SUM(accepted_quantity) / Sum(po_quantity))*100)-100) AS excessPercentage, g.grn_no AS grnNo, u.unit_name AS unitName,po.po_number AS poNumber,g.grn_no AS grnNumber,g.grn_id AS grnId from " + appSettings.procure_db + ".grn_items gi left join " + appSettings.sales_db + ".so_invoice_details soi on soi.sale_order_id = gi.sale_order_id left join " + appSettings.procure_db + ".grn g on g.grn_id = gi.grn_id left join " + appSettings.masters_db + ".vendors v on v.vendor_id = g.vendor_id left join " + appSettings.masters_db + ".unitcodes u on u.unit_code_id = g.unit_id left join " + appSettings.procure_db + ".purchase_order po on po.purchase_order_id = gi.po_id left join " + appSettings.masters_db + ".items it on it.item_id = gi.item_id where gi.po_id = " + savedGrnDto.poId + " group by gi.sale_order_id,gi.grn_item_id having excessPercentage > 5 order by gi.sale_order_id";
          let grnCountResult = await conManager.query(grnCount);
          console.log("grnCountResult" + grnCountResult);
          const perFlagSet = new Set<boolean>();

          let poNumber = undefined;
          let soNumber = undefined;
          let grnNumber = undefined;
          let grn = undefined;
          let unitName = undefined;
          let item = undefined;
          let vendorName = undefined;
          let poQty = 0;
          let grnQty = 0;
          let excessPer = 0;
          let messageContent = '';
          const time = moment().format("DD-MM-YYYY HH:mm")
          for (const res of grnCountResult) {
            console.log("res res" + res.grnId);
            soNumber = res.soNo;
            item = res.item;
            poNumber = res.poNumber;
            grnNumber = res.grnNumber;
            unitName = res.unitName;
            poQty = res.poQuantity;
            vendorName = res.vendorName;
            grnQty = Math.round(res.acceptedQuantity);
            excessPer = Math.round(res.excessPercentage);
            grn = res.grnId;

            let message = "\\n*Item :* " + (item != undefined ? item : 'No Data\\n') +
              "\\n*PO Quantity :* " + (poQty > 0 ? poQty : 'No Data\\n') +
              "\\n*Grn Quantity :* " + (grnQty > 0 ? grnQty : 'No Data\\n') +
              "\\n*Excess Perc% :* " + (excessPer > 0 ? excessPer : 'No Data\\n') + '\\n';
            messageContent += message
            // messageContent.push(message);
          }
          console.log("messageContent");
          console.log(messageContent);

          let urlMsg = '*click the below link for detail view*';
          let reportUrl = appSettings.whatsapp_redirection_url + '/grn-detail-view/' + grn;
          console.log("reportUrl" + reportUrl)
          if (grnCountResult.length > 0) {
            // const alertMessage = await new BroadCastMessageRequest(27,
            //   time +
            //   " \n*Unit :* " + (unitName != undefined ? unitName : 'No Data\n') +
            //   " \n*Vendor :* " + (vendorName != undefined ? vendorName : 'No Data\n') +
            //   " \n*GRN Number :* " + (grnNumber != undefined ? grnNumber : 'No Data\n') +
            //   "\n*PO Number :* " + (poNumber != undefined ? poNumber : 'No Data\n') +
            //   "\n*SO Number :* " + (soNumber != undefined ? soNumber : 'No Data\n') + '\n' +
            //   messageContent + '\n\n' + urlMsg + '\n' + reportUrl + '\n')
            // const messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(alertMessage);
            //whatsapp broadcast API calling to facebook

            const parameters = [
              { "type": "text", "text":`\\n *Time* : ${time} \\n *UnitName* : ${unitName ? unitName : 'No Data'} \\n *VendorName* : ${vendorName ? vendorName :"No Data"} \\n *GRN Number* : ${grnNumber ? grnNumber :"No Data"} \\n *Po Number* : ${poNumber ? poNumber : "No Data"} \\n *SO Number* : ${soNumber ? soNumber :"No Data"} \\n ${messageContent} `  },
              // { "type": "text", "text": unitName != undefined ? unitName : 'No Data' },
              // { "type": "text", "text": vendorName != undefined ? vendorName : 'No Data' },
              // { "type": "text", "text": grnNumber != undefined ? grnNumber : 'No Data' },
              // { "type": "text", "text": poNumber != undefined ? poNumber : 'No Data' },
              // { "type": "text", "text": soNumber != undefined ? soNumber : 'No Data' },
              // { "type": "text", "text": messageContent },
            ];
            console.log('parameters', parameters)
            const contacts = whatsApp.contacts;
            let statusFlag
            for (const contact of contacts) {
              const req = await new MessageParameters(contact, 'bmr_proc_grn_excess_alert', parameters, 'en_us')

              const messageStatus = await this.wpService.sendMessageThroughFbApi(req);
              console.log('messageStatus', messageStatus)

              if (!messageStatus.status) {
                statusFlag = false
                break
              } else {
                statusFlag = true
                const whatsapplogDto = new WhatsAppLogDto(contact, 'bmr_proc_grn_excess_alert', 'BMR', GlobalVariableValues.companyId, GlobalVariableValues.procurementmoduleId)
                await this.wtsAppBroadCatService.createWhatappLog(whatsapplogDto)
              }
              console.log(messageStatus);
            }
          }
          const response = new grnResponse(true, isUpdate ? 11100 : 11101, isUpdate ? 'GRN Updated Successfully' : 'GRN Created Successfully', savedGrnDto)
          const newLogDto = new LogsDto(1, 'GRN Creation', 'Grn', 0, true, response.internalMessage, '')
          let res = await this.logService.createLog(newLogDto);
          console.log(res);
          return response;
        } else {
          throw new ErrorResponse(11106, 'Something Went wrong!');
        }
      } else {
        throw new ErrorResponse(11106, 'Something Went wrong in saving!');
      }
    }
    catch (error) {
      manager.releaseTransaction();
      throw error;
    }
  }

  async getGrnQtyByPoId(poReq: GrnQtyRequest): Promise<GrnQtyResponseModel> {
    //  console.log(employeeId);
    try {

      const qty = await this.grnRepo.getGrnQty(poReq);
      if (qty) {
        const response = new GrnQtyResponseModel(true, 11058, 'qty retreived', new grnQtyDto(qty.quantity))
        return response;
      } else {
        const response = new GrnQtyResponseModel(true, 11058, 'qty retreived', new grnQtyDto(0))
        return response;
      }
    } catch (error) {
      return error;
    }


  }

  async getGrnById(grnId: number): Promise<Grn> {
    //  console.log(employeeId);
    const Response = await this.grnRepository.findOne({
      where: { grnId: grnId },
    });
    // console.log(employeeResponse);
    if (Response) {
      return Response;
    } else {
      return null;
    }
  }

  async getAllGrnData(req?: UnitRequest): Promise<AllGrnResponseModel> {
    // let grndata: Grn[]
    console.log(req, 'unit req')
    let concatString = ''
    if (req) {

      if (req.unitId && req.unitId != 5) {
        concatString = `where g.unit_id = ` + req.unitId;
      }
      const manager = getManager();

      let query = `SELECT count(*),g.grn_id as grnId,so.sale_order_no,soi.po_number,g.unit_id as unitId,p.status as poStatus,p.po_type as poType,p.po_number as poNumber,v.vendor_name as vendor,g.grn_no as grnNumber,g.grn_date as grnDate,g.inv_no as invoiceNumber,g.invoice_date as InvoiceDate,soi.po_number as poNumbers,u.unit_name as unitName,gi.plant_lot_number as batchNumber,gii.item_category_id as itemCategoryId
       FROM ` + grnTable + ` g
       LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi on gi.grn_id  = g.grn_id
       LEFT JOIN ${appSettings.procure_db}.grn_items gii on gii.grn_id  = g.grn_id
        LEFT JOIN `+ poTable + ` p ON g.po_id=p.purchase_order_id 
        LEFT JOIN `+ poItemsTable + ` pi ON p.purchase_order_id=pi.purchase_order_id 
        LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
        LEFT JOIN `+ soInvTable + ` soi ON pi.sale_order_id=soi.sale_order_id 
        LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id=p.vendor_name 
        LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=g.unit_id
        `+ concatString + ` group by g.grn_id `;
      query = query + ' ORDER BY g.created_at DESC '
      const grnData = await manager.query(query);
      const res = new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grnData);
      const newLogDto = new LogsDto(1, 'view grn details', 'GrnItems', 0, true, '', '')
      let response = await this.logService.createLog(newLogDto);
      console.log(response);
      return res
      // } else {
      //   const grndata = await this.grnRepository.find({
      //     relations: ['grnItemsInfo'],
      //     order: { createdAt: "DESC" },
      //   });
      //   return new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grndata);

      // }
    }
    // if (grndata) {
    // } else {
    //   throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    // }
  }

  /**
   * gets all  val addition one types details  
   * @returns all the val addition one type details .
   */
  async getAllGrnDetails(req?: UnitRequest): Promise<AllGrnResponseModel> {
    let grndata: Grn[]
    if (req) {
      if (req.unitId) {
        grndata = await this.grnRepository.find({
          where: { unitId: req.unitId },
          relations: ['grnItemsInfo'],
          order: { createdAt: "DESC" },
        });

      } else {
        grndata = await this.grnRepository.find({
          relations: ['grnItemsInfo'],
          order: { createdAt: "DESC" },
        });
      }
    }
    if (grndata) {
      const grnInfo: AllGrnDto[] = [];
      for (const grn of grndata) {
        // let poDetails =null;
        // let poData
        // if(grn.poId){
        //     const poReq: PoRequest = {
        //         purchaseOrderId: grn.poId
        //     }
        //     poDetails = await this.poService.getPoNumberById(poReq);
        //     poData = new PoNumbersModel(grn.poId,poDetails.poNumber);
        // }
        const poDetails = await this.poService.getPoNumberById(grn.poId);
        let soNumber;
        let soId;
        let pmStatus;
        if (poDetails) {
          let saleOrderDetails = null;
          let soTrackData = null;
          if (poDetails.saleOrderId) {
            const soReq: saleOrder = {
              saleOrderId: poDetails.saleOrderId
            }
            saleOrderDetails = await this.saleService.getSaleOrderDetailsForId(soReq);
            soNumber = saleOrderDetails.saleOrderNumber;
            soId = poDetails.saleOrderId;
            soTrackData = await this.saleService.getPmStatus(soReq);
            pmStatus = soTrackData.data.pmStatus;
          }
        }
        const poData = new PoNumbersModel(grn.poId, poDetails.poNumber);

        const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grn.vendorId });
        // console.log(vendorDetails.data);
        // logIntermediateObjects({logger: this.logger, functionName: this.vendorService.getVendorDataById.name, loggingMode: 'trace'}, {vendorDetails});
        const vendorData = new PoVendorDataModel(grn.vendorId, vendorDetails.data.vendorCode, vendorDetails.data.vendorName, vendorDetails.data.contactPerson, vendorDetails.data.contactNumber, vendorDetails.data.street, vendorDetails.data.apartment, vendorDetails.data.city, vendorDetails.data.postalCode);

        const grnItems: grnItemsDataModel[] = [];

        // console.log(vendorData);
        for (const grnItem of grn.grnItemsInfo) {
          const itemcategorydata = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: grnItem.itemCategoryId });

          //   // logIntermediateObjects({logger: this.logger, functionName: this.itemCategoryService.getItemCategoryById.name, loggingMode: 'trace'}, {itemcategorydata});

          const itemdata = await this.itemService.getItemById({ itemId: grnItem.itemId });
          const sizeData = await this.sizeService.getSizeDataById({ sizeId: grnItem.sizeId });

          const taxData = await this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });


          // let sizeData = new SizesDropDownDto(1, '5*2');

          // let QtyData = await this.grnService.getGrnQtyByPoId({ purchaseOrderId: poIdReq.purchaseOrderId, itemCategoryId: grnItem.itemCategory, itemId: grnItem.itemName });
          //   console.log('show')
          //   console.log(QtyData)

          //   // logIntermediateObjects({logger: this.logger, functionName: this.itemService.getItemById.name, loggingMode: 'trace'}, {itemdata});

          const grnItemObject = new grnItemsDataModel(
            grnItem.grnId,
            itemcategorydata,
            itemdata,
            sizeData,
            grnItem.poQuantity,
            grnItem.acceptedQuantity,
            grnItem.rejectedQuantity,
            grnItem.receivedQuantity,
            grnItem.unitPrice,
            grnItem.discountPercentage,
            grnItem.discountAmount,
            taxData,
            grnItem.taxAmount,
            grnItem.totalAmount,
            grnItem.createdUser,
            grnItem.updatedUser,
            grnItem.status,
          )
          grnItems.push(grnItemObject);
        }

        const grnModel = new AllGrnDto(grn.grnId, grn.grnDate, grn.InvoiceDate, grn.grnNumber, grn.unitId, grn.invoiceNumber, poData, grn.totalQuantity, grn.totalDiscount, grn.totalTax, grn.totalCost, grn.remarks, grn.approvar, grn.status, grn.createdUser, grn.updatedUser, vendorData, grnItems, poDetails.poStatus, poDetails.poType, soNumber, soId, pmStatus, poDetails.poNumber);
        grnInfo.push(grnModel)
      }
      return new AllGrnResponseModel(true, 1108, 'GRN Details Retrieved Succesfully', grnInfo);
    } else {
      throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    }
  }

  async getGrnDataById(grnIdReq: GrnIdRequest): Promise<GrnDetailViewResponseModel> {

    const grndata = await this.grnRepo.getGrnData(grnIdReq.grnId);
    // console.log(grndata);
    let poData;
    if (grndata) {
      let poDetails = null;
      if (grndata.poId) {
        const poReq: PoRequest = {
          purchaseOrderId: grndata.poId
        }
        poDetails = await this.poService.GetPoDataDetailsForPoId(poReq);
        poData = new PoNumbersModel(grndata.poId, poDetails.data.purchaseOrderNo);
      }
      // console.log(poDetails);
      const grnItems: grnItemsDataModel[] = [];
      const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grndata.vendorId });
      // console.log(vendorDetails.data);
      // logIntermediateObjects({logger: this.logger, functionName: this.vendorService.getVendorDataById.name, loggingMode: 'trace'}, {vendorDetails});
      const vendorData = new PoVendorDataModel(grndata.vendorId, vendorDetails.data.vendorCode, vendorDetails.data.vendorName, vendorDetails.data.contactPerson, vendorDetails.data.contactNumber, vendorDetails.data.street, vendorDetails.data.apartment, vendorDetails.data.city, vendorDetails.data.postalCode);


      // console.log(vendorData);
      for (const grnItem of grndata.grnItemsInfo) {
        const itemcategorydata = await this.itemCategoryService.getItemCategoryById({ itemCategoryId: grnItem.itemCategoryId });

        //   // logIntermediateObjects({logger: this.logger, functionName: this.itemCategoryService.getItemCategoryById.name, loggingMode: 'trace'}, {itemcategorydata});

        const itemdata = await this.itemService.getItemById({ itemId: grnItem.itemId });
        const sizeData = await this.sizeService.getSizeDataById({ sizeId: grnItem.sizeId });
        // const sizeData = new SizesDropDownDto(1, '5*2');
        const taxData = await this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });
        const saleOrderDetails = await this.saleService.getSaleOrderDetailsForId({ saleOrderId: grnItem.saleOrderId });
        console.log('saleOrderDetailsdfghjkl');
        console.log(saleOrderDetails);



        // let QtyData = await this.grnService.getGrnQtyByPoId({ purchaseOrderId: poIdReq.purchaseOrderId, itemCategoryId: grnItem.itemCategory, itemId: grnItem.itemName });
        //   console.log('show')
        //   console.log(QtyData)

        //   // logIntermediateObjects({logger: this.logger, functionName: this.itemService.getItemById.name, loggingMode: 'trace'}, {itemdata});

        const grnItemObject = new grnItemsDataModel(
          grnItem.grnId,
          itemcategorydata,
          itemdata,
          sizeData,
          grnItem.poQuantity,
          grnItem.acceptedQuantity,
          grnItem.rejectedQuantity,
          grnItem.receivedQuantity,
          grnItem.unitPrice,
          grnItem.discountPercentage,
          grnItem.discountAmount,
          taxData,
          grnItem.taxAmount,
          grnItem.totalAmount,
          grnItem.createdUser,
          grnItem.updatedUser,
          grnItem.status,
          saleOrderDetails.saleOrderNumber,
          saleOrderDetails.poNumber,
        )
        grnItems.push(grnItemObject);
      }

      const grndataModel = new GrnDetailViewModel(grndata.grnId, grndata.grnDate, grndata.InvoiceDate, grndata.grnNumber, grndata.invoiceNumber, poData, grndata.totalQuantity, grndata.totalDiscount, grndata.totalTax, grndata.totalCost, grndata.remarks, grndata.approvar, grndata.status, 'Admin', 'Admin', vendorData, grnItems)
      const response = new GrnDetailViewResponseModel(true, 1108, ' GRN Details Retrieved Succesfully', grndataModel);
      return response;
    } else {
      throw new ErrorResponse(9999, 'Failed To Get GRN Info')
    }
  }

  async getGrnDataByIdForReturn(grnIdReq: GrnIdRequest): Promise<GrnItemReturnResponse> {
    const grndata: Grn = await this.grnRepo.getGrnData(grnIdReq.grnId);
    if (grndata) {
      const grnReturnData = new GrnDetailsForReturn();
      grnReturnData.grnDate = grndata.grnDate
      grnReturnData.grnId = grndata.grnId;
      grnReturnData.grnNumber = grndata.grnNumber;
      grnReturnData.invoiceDate = grndata.InvoiceDate;
      grnReturnData.invoiceNumber = grndata.invoiceNumber;
      grnReturnData.vendorId = grndata.vendorId;
      const vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grndata.vendorId });
      grnReturnData.vendorName = vendorDetails.data.vendorName;
      const items: GrnItemsForReturn[] = [];
      for (const grnItem of grndata.grnItemsInfo) {
        // get available stock 
        const getStock = await this.stockRepo.findOne({ where: { stockId: grnItem.stockId } });
        if (Number(getStock.physicalQuantity) > 0) {
          const item = new GrnItemsForReturn();
          // get item Category, item Sub Category, item, 
          const itemCategoryReq = new ItemCategoryReq(grnItem.itemCategoryId);
          const itemCategoryDetails = this.itemCategoryService.getItemCategoryById(itemCategoryReq);
          if (!itemCategoryDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item Category');
          }

          // get item details for item id 
          const itemReq = new ItemRequest(grnItem.itemId);
          const itemDetails = this.itemService.getItemById(itemReq);
          if (!itemDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item');
          }

          // const size = new SizeRequest(grnItem.sizeId);
          // const sizeDetails = this.sizeService.getSizeDataById(size);
          // if (!size) {
          //   throw new ErrorResponse(1111, 'Failed to Get Size');
          // }

          // get item sub category details for item sub category id
          const itemSubCategoryReq = new ItemSubCategoryRequest(grnItem.itemSubCategoryId);
          const itemSubCategoryDetails = this.subCategoryService.getItemSubCategoryForId(itemSubCategoryReq);
          if (!itemSubCategoryDetails) {
            throw new ErrorResponse(1111, 'Failed to Get Item Category');
          }

          // get Tax
          const taxData = this.taxService.getTaxForId({ taxId: grnItem.taxPercentage });
          const remainingQty = grnItem.receivedQuantity - grnItem.returnedQuantity;
          const qty = (getStock.physicalQuantity < remainingQty) ? getStock.physicalQuantity : remainingQty;


          await Promise.all([itemCategoryDetails, itemDetails, itemSubCategoryDetails, taxData]).then(res => {
            const itemCategory = (res[0]) ? res[0] : null;
            const itemSubCategory = (res[2]) ? res[2] : null;
            const itemData = (res[1]) ? res[1] : null;
            // const size = (res[2]) ? res[2] : null;
            const tax = (res[3]) ? res[3] : null;

            item.itemCategoryId = itemCategory.itemCategoryId;
            item.itemCategoryName = itemCategory.itemCategory;
            item.itemSubCategoryId = itemSubCategory.itemSubCategoryId;
            item.itemSubCategoryName = itemSubCategory.itemSubCategory;
            item.itemId = itemData.itemId;
            item.itemName = itemData.itemName;
            // item.sizeId = size.sizeId;
            // item.sizeName = size.sizeName;
            const itemCost = qty * grnItem.unitPrice;
            //discount
            item.discountPercentage = Number(grnItem.discountPercentage);
            item.discountAmount = Number((itemCost) * (grnItem.discountPercentage / 100));

            //tax
            item.taxPercentage = Number(tax.taxPercentage);
            item.taxAmount = Number(((itemCost) - item.discountAmount) * (tax.taxPercentage / 100));

            item.grnItemId = grnItem.grnItemId;
            item.stockId = grnItem.stockId;
            item.grnReceivedQty = Number(remainingQty);
            item.grnReturnQty = Number(grnItem.returnedQuantity);
            item.availQty = Number(getStock.physicalQuantity);
            item.unitPrice = Number(grnItem.unitPrice);
            item.grnTotalReturnPrice = Number((itemCost - item.discountAmount + item.taxAmount));
            item.grnReturnQty = Number(qty);
            items.push(item);
          })
        }
      }
      grnReturnData.grnItems = items;
      return new GrnItemReturnResponse(true, 1111, 'Grn items Retrieved Successfully', grnReturnData)
    } else {
      return new GrnItemReturnResponse(false, 9999, 'No Data Found')
    }

  }

  async getAllActiveGrnNumbers(req?: UnitRequest): Promise<GrnNumberResponseModel> {
    let wherCondition = {};
    if (req.unitId != 5) {
      wherCondition = { where: { unitId: req.unitId } };
    }
    const grnNumbers = await this.grnRepository.find(
      {
        ...wherCondition,
        select: ['grnId', 'grnNumber'],
        order: { grnId: "DESC" }
      });
    if (grnNumbers.length > 0) {
      grnNumbers.map(grn => new GrnNumberDto(grn.grnId, grn.grnNumber));
      return new GrnNumberResponseModel(true, 11059, 'Grn Numbers retrived successfully', grnNumbers)
    } else {
      throw new ErrorResponse(99998, 'Grn Numbers not Found');
    }
  }

  async getGrnReturnAutoFillDataByGrnNumber(grnIdReq: GrnIdRequest): Promise<GrnReturnAutoFillModel> {
    const grndata = await this.grnRepo.findOne({ where: { grnId: grnIdReq.grnId } });
    const obj = new GrnReturnAutoFillDto(undefined, grndata.grnId, grndata.grnNumber, 'BAJ-VSP-ANAKAPALLI', grndata.InvoiceDate, 'INV#123', 2, 100, 'BAJ-VSP-ANAKAPALLI//1', 'DC/BAJ-VSP-HEAD OFFICE/2018-19/1');
    return new GrnReturnAutoFillModel(true, 1, 'Grn Return auto fill data', obj);
  }

  async getGrnItemReceivedQtyByGrnIdandItem(grnItemReq: GrnItemReceivedQtyRequest): Promise<GrnItemReceivedQtyResponse> {
    return new GrnItemReceivedQtyResponse(true, 11, '', 4)
  }


  async getAllGrnReport(req?: GrnReportRequest): Promise<AllGrnReportResponse> {
    try {
      const manager = getManager();
      let query = `SELECT g.grn_date as grnDate,g.grn_no as grnNumber,g.inv_no as invoiceNumber,gi.po_quantity as grnQty,gi.po_id as poId, vendor.vendor_name as vendorName,po.purchase_order_date as poDate,po.po_number as poNumber,so_invoice.po_number as saleOrder,so_invoice.sale_order_id,g.grn_Id,g.unit_id,u.unit_name as plant,po.po_type as poType,isc.item_sub_category as itemSubCategory,i.item_name as item,g.invoice_date as invDate,i.item_id,gi.accepted_quantity as acptQty,gi.received_quantity as rcvdQty,gi.rejected_quantity as rjctQty,gi.unit_price as unitPrice ,t.tax_name AS taxPer, gi.tax_amount as taxAmount,gi.tot_amount as totalAmount, gi.grn_item_id,g.created_at as createdDate,(((gi.accepted_quantity / gi.po_quantity)*100)) AS excessPercentage,po.expected_delivery_date as expectedDeliveryDate FROM ` + appSettings.procure_db + `.grn g
      LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
      LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
      LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = gi.item_id
      LEFT JOIN ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = gi.po_id
      LEFT JOIN ` + appSettings.procure_db + `.purchase_order_items po_item ON po_item.purchase_order_id = g.po_id
      LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id = g.unit_id
      LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details so_invoice ON so_invoice.sale_order_id = gi.sale_order_id
      LEFT JOIN ` + appSettings.masters_db + `.vendors vendor ON vendor.vendor_id = g.vendor_id
      LEFT JOIN ` + appSettings.masters_db + `.taxes t ON t.tax_id = gi.tax_per
      WHERE g.grn_id > 0 `
      if (req.fromDate != undefined) {
        query = query + ' and g.grn_date between  "' + req.fromDate + '" and "' + req.toDate + '"';
      }
      if (req.selectedCreatedFromDate != undefined) {
        query = query + ' and date(g.created_at) >= "' + req.selectedCreatedFromDate + '" and  date(g.created_at) <= "' + req.selectedCreatedToDate + '"';
      }
      if (req.saleOrderId) {
        query = query + ' and so_invoice.sale_order_id = ' + req.saleOrderId;
      }
      if (req.grnNumber) {
        query = query + ' and g.grn_Id = ' + req.grnNumber;
      }
      if (req.poNumber) {
        query = query + ' and gi.po_id = ' + req.poNumber;
      }
      if (req.vendorName) {
        query = query + ' and vendor.vendor_id = ' + req.vendorName;
      }
      if (req.unitId && req.unitId != 5) {
        query = query + ' and g.unit_id = ' + req.unitId;
      }
      if (req.itemSubCategoryId) {
        query = query + ' and gi.item_sub_category_id = "' + req.itemSubCategoryId + '"';
      }
      if (req.poType) {
        query = query + ' and po.po_type = "' + req.poType + '"';
      }
      if (req.itemNameId) {
        query = query + ' and i.item_id = ' + req.itemNameId;
      }
      if (req.excessPercent) {
        query = query + ' and (((gi.accepted_quantity / gi.po_quantity)*100)) > ' + req.excessPercent
      }

      //  if (req.invoiceNumber) {
      //   query = query + ' and g.invoiceNumber = ' + req.invoiceNumber;
      //  }
      query = query + ` GROUP BY gi.grn_item_id ORDER BY g.grn_date DESC `
      const data = await manager.query(query)
      if (data.length > 0) {
        const response = new AllGrnReportResponse(true, 11208, "GRN Report retrieved successfully", data);
        return response;
      } else {
        throw new AllGrnReportResponse(false, 99998, 'No Record Found');
      }
    } catch (err) {
      return err
    }

  }
  async getSoDropForGrnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT si.sale_order_id as saleOrderId , si.po_number AS soNumber ,  g.unit_id FROM ` + appSettings.procure_db + `.grn g
    LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
    LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = gi.sale_order_id
    WHERE si.sale_order_id> 0 `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and g.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY si.sale_order_id  ORDER BY soNumber `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1421, 'No data')
    }
  }
  async getPoDropForGrnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT  g.po_id  as purchaseOrderId , po.po_number AS poNumber , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = gi.po_id
  LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details si ON si.sale_order_id = gi.sale_order_id
  WHERE g.po_id> 0 `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and g.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY g.po_id `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1421, 'No data')
    }
  }
  async getItemSubDropForGrnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT isc.item_sub_category_id AS itemSubCategoryId, isc.item_sub_category AS itemSubCategory , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.masters_db + `.item_sub_categories isc ON isc.item_sub_category_id = gi.item_sub_category_id
  WHERE isc.item_sub_category_id> 0 `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and g.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY isc.item_sub_category_id `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1421, 'No data')
    }
  }
  async getItemDropForGrnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT i.item_id AS itemId , i.item_name AS item , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id
  LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id = gi.item_id
  WHERE i.item_id> 0 `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and g.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY i.item_id `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1421, 'No data')
    }
  }
  async getVendorDropForGrnReport(req: UnitRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = ` SELECT g.vendor_id as vendorId , vendor.vendor_name AS vendorName , g.unit_id FROM ` + appSettings.procure_db + `.grn g
  LEFT JOIN ` + appSettings.masters_db + `.vendors vendor ON vendor.vendor_id = g.vendor_id
  WHERE g.vendor_id> 0 `;
    if (req.unitId && req.unitId != 5) {
      query = query + ' and g.unit_id = ' + req.unitId;
    }
    query = query + ` GROUP BY g.vendor_id `;
    const data = await manager.query(query);
    if (data) {
      return new CommonResponse(true, 1421, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1421, 'No data')
    }
  }

  async getTransferredSosDataForGrnGrid(req?: UnitRequest) {

    const transferredSoIds = await this.soService.getTransferredSaleOrders();
    if (transferredSoIds.status) {
      //below line using to convert array of objets to array of properties
      const arrayOfSoIds = transferredSoIds.data.map(({ saleOrderId }) => saleOrderId)
      let concatString = ''
      if (req) {

        if (req.unitId && req.unitId != 5) {
          concatString = `and g.unit_id = ` + req.unitId;
        }
      }
      const manager = getManager();
      const query = `SELECT count(*),g.grn_id as grnId,so.sale_order_no,soi.po_number,g.unit_id as unitId,p.status as poStatus,p.po_type as poType,p.po_number as poNumber,v.vendor_name as vendor,g.grn_no as grnNumber,g.grn_date as grnDate,g.inv_no as invoiceNumber,g.invoice_date as InvoiceDate,group_concat(soi.po_number) as poNumbers,u.unit_name as unitName FROM ` + grnTable + ` g
                LEFT JOIN `+ poTable + ` p ON g.po_id=p.purchase_order_id 
                LEFT JOIN `+ poItemsTable + ` pi ON p.purchase_order_id=pi.purchase_order_id 
                LEFT JOIN `+ soTable + ` so ON pi.sale_order_id=so.sale_order_id 
                LEFT JOIN `+ soInvTable + ` soi ON pi.sale_order_id=soi.sale_order_id 
                LEFT JOIN `+ vendorsTable + ` v ON v.vendor_id=p.vendor_name 
                LEFT JOIN ` + appSettings.masters_db + `.unitcodes u ON u.unit_code_id=g.unit_id
                where  pi.sale_order_id IN (` + arrayOfSoIds.toString() + `) ` + concatString + `  group by g.grn_id`;
      const grnData = await manager.query(query);
      if (grnData && grnData.length > 0) {
        return new CommonResponse(true, 1525, 'Grn Details Retrieved Successfully', grnData);
      } else {
        throw new ErrorResponse(9999, 'No Data Found');
      }
    } else {
      throw new ErrorResponse(9999, 'No Transferred SaleOrders  Found');
    }
  }





  // async getAllGrnReport(req?: GrnReportRequest): Promise<AllGrnReportResponse> {
  //   try {
  //     const grnInfo = this.grnRepo
  //       .createQueryBuilder('Grn')
  //       .select([
  //         'Grn.grn_date as grnDate,Grn.grn_no as grnNumber, Grn.inv_no as invoiceNumber, Grn.total_cost as totalCost, Grn.po_id as poId, Grn.vendor_id as vendorId, purchase_order.purchase_order_date as poDate, purchase_order.po_number as poNumber, purchase_order.sale_order_id as saleOrderId '
  //       ])
  //       .leftJoin('purchase_order', 'purchase_order',  'Grn.po_id=purchase_order.purchase_order_id')

  //     if (req) {
  //       if (req.fromDate && req.toDate) {
  //         grnInfo.where('Date(grn_date) between "' + moment(req.fromDate).format('YYYY-MM-DD') + '" and "' + moment(req.toDate).format('YYYY-MM-DD') + '"')
  //       }

  //       if (req.soNumber) {
  //         grnInfo.andWhere('purchase_order.sale_order_id =' + req.soNumber)
  //       }

  //       if (req.poNumber) {
  //         grnInfo.andWhere('Grn.po_id =' + req.poNumber)
  //       }

  //       if (req.vendorName) {
  //         grnInfo.andWhere('vendor_name =' + req.vendorName)
  //       }

  //       if (req.grnNumber) {
  //         grnInfo.andWhere('grn_id =' + req.grnNumber)
  //       }
  //     }
  //     const grnDetails = await grnInfo.getRawMany();
  //     console.log(grnDetails);
  //     if (grnDetails && grnDetails.length > 0) {
  //       console.log(grnDetails);
  //       const grnInformation: AllGrnReportDto[] = [];
  //       for (const grn of grnDetails) {

  //         let saleOrderDetails = null;
  //         let soNumber;
  //         let soId;
  //         let soDate;
  //         if (grn.saleOrderId) {
  //           const soReq: saleOrder = {
  //             saleOrderId: grn.saleOrderId
  //           }
  //           saleOrderDetails = await this.saleService.getSaleOrderDetailsForId(soReq);

  //           soNumber = saleOrderDetails.saleOrderNumber;
  //           soId = grn.saleOrderId;
  //           soDate = saleOrderDetails.soDate
  //           console.log(saleOrderDetails);
  //         }

  //         let vendorDetails = await this.vendorService.getVendorDataById({ vendorId: grn.vendorId });
  //         if (!vendorDetails) {
  //           throw new ErrorResponse(9999, 'didn\'t get vendor info')
  //         }
  //         const vendor = vendorDetails.data.vendorName
  //         console.log(vendorDetails);
  //         const grnModel = new AllGrnReportDto(grn.grnId, grn.grnDate, grn.grnNumber, grn.invoiceNumber, grn.poDate, soDate, grn.totalCost, vendor, grn.createdUser, grn.updatedUser, soNumber, grn.poNumber);
  //         console.log(grnModel);
  //         grnInformation.push(grnModel)
  //       }
  //       return new AllGrnReportResponse(true, 1108, 'GRN Report Retrieved Succesfully', grnInformation);
  //     } else {
  //       return new AllGrnReportResponse(false, 1109, 'No Data Found');
  //     }
  //   } catch (error) {
  //     return error;
  //   }
  //}
  // @Cron('0 19 * * *')
  async getGrnUsage() {
    const manager = getManager();
    try {

      let query = `SELECT puc.unit_name,COUNT(*) AS cnt FROM erpx_dev_procurement.grn g
      LEFT JOIN erpx_dev_masters.unitcodes puc ON puc.unit_code_id = g.unit_id WHERE DATE(g.created_at)=DATE(NOW())
          GROUP BY g.unit_id ORDER BY g.unit_id `
      const gData = await manager.query(query);
      const messageType = new Date();
      const month = messageType.getMonth() + 1
      const GDate = messageType.getFullYear() + '-' + month + '-' + messageType.getDate();
      const time = messageType.toLocaleTimeString()
      let messageStatus
      if (gData.length > 0) {
        let grnData = GDate + " : " + time + "*\n";
        for (const sd of gData) {
          grnData += sd.unit_name + "   *" + sd.cnt + "*\n";
        }
        //whatsapp broadcast API calling
        messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(5, grnData, [whatsApp.UsageReport]));

        // const message =await new MessageRequest(whatsApp.UsageReport,`GRN :${GDate} : ${time}`, grnData, "Schemax")
        // console.log(message);
        // var messageStatus= await this.wpService.sendPersonalMessage(message);
      } else {
        const NoGRNData = GDate + " : " + time + "*\n" + 'No Data';
        //whatsapp broadcast API calling
        messageStatus = await this.wtsAppBroadCatService.sendWhatsappMessage(new BroadCastMessageRequest(5, NoGRNData, [whatsApp.UsageReport]));
        //  const message = await new MessageRequest(whatsApp.UsageReport,`GRN :${GDate} : ${time}`, "No data", "Schemax")
        //  console.log(message);
        //  var messageStatus=await this.wpService.sendPersonalMessage(message);
      }
      console.log(messageStatus);
      return new CommonResponse(true, 11108, "Message Sent Successfully", gData)
    }
    catch (error) {
      return new CommonResponse(false, 11108, "No data found")
    }
  }

  async getGrnByPoId(poReq: GrnQtyRequest): Promise<CommonResponse> {
    try {
      const grnDetails = await this.grnRepo.getGrnDataByPoId(poReq);
      if (grnDetails) {
        const response = new CommonResponse(true, 11058, 'data exist', grnDetails)
        return response;
      } else {
        const response = new CommonResponse(true, 11058, 'data not exist')
        return response;
      }
    } catch (error) {
      return error;
    }
    return
  }

  async grninfoforpending(req?: UnitRequest): Promise<CommonResponse> {
    try {
      let concatString = ''
      // if (req) {

      if (req.unitId && req.unitId != 5) {
        concatString = `where g.unit_id = ` + req.unitId;
      }
      const manager = getManager();
      const query = 'SELECT gi.item_sub_category_id AS itemSubCategoryId,gi.unit_price as unitPrice,i.item_category_id AS itemCategoryId,brand AS brandId,gi.item_id AS itemId,g.created_user AS createdUser,s.location_id AS locationId,gi.size_id AS sizeId,gi.po_id AS poId,gi.grn_item_id AS grnItemId,ROUND(SUM(COALESCE(s.quantity, 0))) AS physicalQuantity,g.vendor_id AS vendorId,v.vendor_name AS vendorName,i.item_name AS itemName,g.unit_id AS grnUnitId,g.inv_no AS invoiceNumber,g.grn_no AS grnNo,gi.grn_id AS grnId,gi.stock_id AS stockId,ROUND(received_quantity) AS receivedQuantity ,gi.sale_order_id AS saleOrderId,ROUND((received_quantity - (SUM(COALESCE(quantity, 0))))) AS balance,gi.inspected_qty as inspectedQty FROM ' + appSettings.procure_db + '.`grn_items` gi LEFT JOIN ' + appSettings.procure_db + '.`grn` g ON gi.grn_id=g.grn_id LEFT JOIN ' + appSettings.masters_db + '.`vendors` v ON g.vendor_id= v.vendor_id LEFT JOIN ' + appSettings.masters_db + '.items i ON i.item_id=gi.item_id LEFT JOIN ' + appSettings.procure_db + '.`stock_log` s ON s.grn_item_id = gi.grn_item_id ' + concatString + ' and g.grn_date > "2023-02-03" and gi.item_category_id = 6 GROUP BY gi.grn_item_id HAVING balance > 0 OR balance IS NULL';
      const result = await manager.query(query)
      if (result) {
        const data = new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
        const newLogDto = new LogsDto(1, 'view grn pending details', 'Grn', 0, true, data.internalMessage, '')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);

        return data
      } else {
        return new CommonResponse(false, 1111, "Error occure")

      }

    } catch (err) {
      return err;
    }
  }
  async getLocationMappedGrns(req: invoiceNumberRequest): Promise<CommonResponse> {
    // const grndataQty = `select * from `
    return
  }

  async saveGrnInspection(req?: GrnInspectionreq): Promise<CommonResponse> {
    const manager = new GenericTransactionManager();
    try {
      await manager.startTransaction()
      let saveFlag = new Set<boolean>()
      if (req.grndata.length != 0) {
        for (const inspection of req.grndata) {
          const grnInspectionEntity = new GrnInspection();
          grnInspectionEntity.grnId = new Grn()
          grnInspectionEntity.grnId.grnId = req.grnId
          grnInspectionEntity.quantity = inspection.quantity
          grnInspectionEntity.reasonId = inspection.reasonId
          grnInspectionEntity.status = inspection.status
          grnInspectionEntity.grnitemId = new GrnItems()
          grnInspectionEntity.grnitemId.grnItemId = req.itemid
          //  const data =await this.grnInspectionRepo.save(grnInspectionEntity) 
          const save = await manager.getRepository(GrnInspection).save(grnInspectionEntity)
          if (!save) {
            saveFlag.add(false)
            manager.releaseTransaction()
            return new CommonResponse(false, 0, 'Something went wrong in Grn Inspection Info Saving')
          }
        }
        const itemsSave = await manager.getRepository(GrnItems).update({ grnItemId: req.itemid, grnId: req.grnId }, { inspectionStatus: true, inspectedQty: req.inspectedQty })
        // await this.GrnItemsRepository.update({grnItemId:req.itemid,grnId:req.grnId},{inspectionStatus:true,inspectedQty:req.inspectedQty})
        if (!(itemsSave.affected)) {
          saveFlag.add(false)
          manager.releaseTransaction()
          return new CommonResponse(false, 0, 'Something went wrong in updating Grn Item inspection status')
        }
        // update inspection status in GRN if all items are inspected
        // const getNotInspectedItems = await this.GrnItemsRepository.find({where:{grnId:req.grnId,inspectionStatus:false}})
        const getNotInspectedItems = await manager.getRepository(GrnItems).find({ where: { grnId: req.grnId, inspectionStatus: false } })
        if (getNotInspectedItems.length == 0) {
          // const updateInspectionStatus = await this.grnRepo.update({grnId:req.grnId},{inspectionStatus:true})
          const updateInspectionStatus = await manager.getRepository(Grn).update({ grnId: req.grnId }, { inspectionStatus: true })
          if (!(updateInspectionStatus.affected)) {
            saveFlag.add(false)
            manager.releaseTransaction()
            return new CommonResponse(false, 0, 'Something went wrong in updating Grn inspection status')
          } else {
            saveFlag.add(true)
          }
        }
      } else {
        manager.releaseTransaction()
        return new CommonResponse(false, 1141, 'No data');
      }
      if (!(saveFlag.has(false))) {
        manager.completeTransaction()
        return new CommonResponse(true, 1, 'Saved successfully')
      } else {
        manager.releaseTransaction()
        return new CommonResponse(false, 1141, 'Something went wrong');
      }

    } catch (error) {
      manager.releaseTransaction()
      return new CommonResponse(false, 500, 'Error saving data', error);
    }
  }

  async getGrnitemById(req: grnIdreq): Promise<CommonResponse> {
    const manager = getManager();
    let query = `Select g.grn_item_id as grnitemId,g.grn_no as grnNo,g.inv_no as invoiceNumber ,gi.received_quantity as receivedqty FROM `
      + appSettings.production_db + `.grn grn_items LEFT JOIN ` + appSettings.procure_db + `.grn_items gi ON gi.grn_id = g.grn_id`;
    if (req.itemid) {
      query = query + 'and gi.grn_item_id =' + req.itemid;

    }
    const details = await manager.query(query);
    if (details) {
      return new CommonResponse(true, 1121, 'Data retrieved successfully', details)

    } else {
      return new CommonResponse(false, 1121, 'No data')

    }
  }

  async getGrnReportData(req?: grnReportreq): Promise<CommonResponse> {
    const manager = getManager();
    let query = `SELECT
        g.grn_id,g.inv_no,g.grn_date,
        gi.grn_item_id,
        g.grn_no,
        gi.received_quantity,
        g.po_id,
        p.po_number,sod.po_number AS soNum,gin.created_at as insDate,g.grn_date,i.item_name AS itemName,
        SUM(CASE WHEN gin.status = 'PASS' THEN gin.quantity ELSE 0 END) AS PASS,
  SUM(CASE WHEN gin.status = 'PASS WITH CONDITION' THEN gin.quantity ELSE 0 END) AS PASS_WITH_CONDITION,
  SUM(CASE WHEN gin.status = 'FAIL' THEN gin.quantity ELSE 0 END) AS FAIL
    FROM grn g 
    LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
    LEFT JOIN purchase_order p ON p.purchase_order_id = g.po_id
    LEFT JOIN grn_inspection gin ON gin.grn_item_id = gi.grn_item_id
LEFT JOIN `+ appSettings.masters_db + `.items i ON i.item_id=gi.item_id
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sod ON sod.inv_details_id = gi.sale_order_id 
        WHERE gi.inspection_status=TRUE `

    if (req?.invoiceNo) {
      query = query + 'and g.inv_no =' + `"${req.invoiceNo}"`
    }
    if (req?.PoId) {
      query = query + 'and g.po_id =' + `${req.PoId}`

    }
    if (req?.startDate) {
      query = query + 'and g.grn_date BETWEEN "' + req.startDate + '" AND "' + req.endDate + '"'

    }
    query = query + ` GROUP BY g.grn_id, g.grn_no, gi.received_quantity, g.po_id, p.po_number `
    const details = await manager.query(query);
    const MapData = new Map<string, grnReportreqsponse>()
    if (details.length > 0) {
      for (const res of details) {
        if (!MapData.has(res.grn_no)) {
          MapData.set(res.grn_no, new grnReportreqsponse(res.grn_no, res.po_number, res.inv_no, res.grn_date, []))
        }
        // const existing = MapData.get(res.grn_no).inspectionData.find(
        //   (e) => e.grnItemId === res.grn_item_id
        // );

        // if (!existing) {
        MapData.get(res.grn_no).inspectionData.push({
          soNum: res.soNum,
          reciedQty: res.received_quantity,
          pass: res.PASS,
          passWithCondition: res.PASS_WITH_CONDITION,
          fail: res.FAIL,
          insDate: res.insDate,
          grnItemId: res.grn_item_id,
          itemName:res.itemName
        });
        // }

      }
      const infoData: grnReportreqsponse[] = Array.from(MapData.values());


      return new CommonResponse(true, 1, 'Data retrieved', infoData)
    } else {
      return new CommonResponse(false, 0, 'No data found')
    }
  } catch(err) {
    throw err
  }
  async getGrnReportPoNum(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT
        g.inv_no,g.grn_date,
        g.grn_no,
        g.po_id,
        p.po_number,gin.created_at as insDate
        
    FROM grn g 
    LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
    LEFT JOIN purchase_order p ON p.purchase_order_id = g.po_id
    LEFT JOIN grn_inspection gin ON gin.grn_item_id = gi.grn_item_id
        LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sod ON sod.inv_details_id = gi.sale_order_id 
        WHERE gi.inspection_status=TRUE `

      query = query + `GROUP BY g.grn_id, g.grn_no, g.po_id, p.po_number `
      const details = await manager.query(query);

      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }
  async getGrnReportExcel(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT
  g.grn_id,g.inv_no,g.grn_date,
  gi.grn_item_id,
  g.grn_no,
  gi.received_quantity,
  g.po_id,
  p.po_number,sod.po_number AS soNum,gin.created_at as inspectionDate,g.grn_date,
  SUM(CASE WHEN gin.status = 'PASS' THEN gin.quantity ELSE 0 END) AS PASS,
  SUM(CASE WHEN gin.status = 'PASS WITH CONDITION' THEN gin.quantity ELSE 0 END) AS PASS_WITH_CONDITION,
  SUM(CASE WHEN gin.status = 'FAIL' THEN gin.quantity ELSE 0 END) AS FAIL
FROM grn g 
LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
LEFT JOIN purchase_order p ON p.purchase_order_id = g.po_id
LEFT JOIN grn_inspection gin ON gin.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.sales_db + `.so_invoice_details sod ON sod.inv_details_id = gi.sale_order_id 
  WHERE gi.inspection_status=TRUE 
  GROUP BY g.grn_id, g.grn_no, gi.received_quantity, g.po_id, p.po_number `
      const details = await manager.query(query);
      return new CommonResponse(true, 1, 'Excel data retrived', details)

    } catch (err) {
      throw err
    }
  }

  async getInspectedGRNNumbersDropdown(): Promise<CommonResponse> {
    try {
      const grnInfo = await this.grnRepo.find({ select: ['grnNumber', 'grnId'], where: { inspectionStatus: true } })
      if (grnInfo.length > 0) {
        return new CommonResponse(true, 0, 'Data retrieved', grnInfo)
      } else {
        return new CommonResponse(false, 1, 'No data found',)
      }
    } catch (err) {
      throw err
    }
  }

  async getInspectedGrnInfo(req: GrnIdRequest): Promise<CommonResponse> {
    try {
      const grnInfo = await this.grnRepo.getInspectedGrnInfo(req)
      let grnInfoModel = []
      if (grnInfo.length > 0) {
        for (const rec of grnInfo) {
          grnInfoModel.push(new InspectedGrnInfoModel(rec.grn_id, rec.grn_no, rec.inv_no, rec.grn_item_id, rec.item_name, rec.po_id, rec.po_quantity, rec.accepted_quantity, rec.rejected_quantity, rec.received_quantity, rec.discount_per, rec.discount_amount, rec.tax_per, rec.tax_amount, rec.tot_amount, rec.unit_price, rec.vendor_id, rec.vendor_name, rec.item_category_id, rec.item_category, rec.item_id, rec.saleOrderNumber, rec.po_number, rec.vendor_code))
        }
        return new CommonResponse(true, 1, 'Data retrieved', grnInfoModel)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }

    } catch (err) {
      throw err
    }
  }
  async getRmWeighment(req: GrnItemIdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT gi.sample_pieces as pieces,gi.reweighment_count as reWeighmentCount,gi.sample_quantity as sampleQty,gi.count,gi.soft_percentage as softPercent,gi.reweighment_quantity as reweighmentQty,g.reweighment_date as reWeighmentDate,gi.grn_item_id as grnItemId,
      re.quantity,re.no_of_crates_or_nets as noOfCrates,s.name as farmer,p.name as product ,s.city,s.street,s.postal_code as postalCode,gi.plant_lot_number as lotNum,g.grn_number as grnNum,g.reweighment_bill_to AS company,u.unit_code_id AS plantId ,gi.indent_id AS indentId,g.vehicle_number AS vehicle,f.name AS dealer ,f.city AS dealerCity,f.street AS dealearStreet,f.postal_code AS dealerPostalCode,g.supplier_type AS supplier
      
      FROM `+ appSettings.rm_procure_db + `.grn_items gi
      LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing re ON re.grn_item_id = gi.grn_item_id
      LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
      LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id= gi.product
      LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
      LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = g.indent_no
      LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii ON ii.indent_id = i.indent_id
      LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = ii.broker
      LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.company = g.reweighment_bill_to AND plant_type = '${UnitTypeEnum.MANUFACTURING_PLANT}'
       where gi.grn_item_id =${req.grnItemId}`

      query = query+ ` GROUP BY re.rm_re_weighing_id `
      const details = await manager.query(query);

      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }
  async getQuantityDeviation(req: QuantityDeviationRequest): Promise<CommonResponse> {

    try {
      const manager = getManager();
      let query = ` SELECT gi.grn_item_id,gi.grn_id,gi.indent_id,gi.farmer,gi.count,gi.boxes as boxes,gi.reweighment_count as reweighmentCount,gi.quantity,gi.plant_lot_number,gi.reweighment_quantity as rmQty,gi.reweighment_boxes as rmBoxesCount,i.indent_code AS indentNum,s.name as farmer, p.name as productName,g.grn_number as grnNum,g.grn_date as grnDate,v.vehicle_num as vehicleNum,i.assign_lead_1,ed.employee_name as graderName FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing rm ON rm.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.transport_db + `.vehicle_assignment v ON v.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db +`.employee_details ed ON ed.employee_id=i.assign_lead_1
     left join  ${appSettings.masters_db}.products p on p.product_id = gi.product
WHERE  gi.reweighment_status = true `
if(req?.harvestType){
  query = query + 'and i.harvest_type  =' + `"${req.harvestType}"`
}
      if (req?.indentId) {
         query += `AND gi.indent_id =  '${req.indentId}'`
      }
      if (req?.grnId) {
         query += `AND gi.grn_id =  '${req.grnId}'`

      }
      if (req?.productId) {
        query = query + ' and gi.product =' + `"${req.productId}"`
      }
      if (req?.farmer) {
         query += `AND gi.farmer =  '${req.farmer}'`

      } 
      if (req?.batchNum) {
        query +=  ` AND gi.plant_lot_number = '${req.batchNum}'`

      }
      if (req?.grnfromDate) {
         query += 'AND g.grn_date BETWEEN "' + req.grnfromDate + '" AND "' + req.grnToDate + '"'

      }
       query += ` GROUP BY gi.grn_item_id`
      const details = await manager.query(query);
      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }
  async getQuantityDeviationIndents(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = ` SELECT gi.grn_item_id,gi.indent_id,gi.farmer,gi.plant_lot_number,i.indent_code AS indentNum,s.name as farmerName,gi.grn_id,g.grn_number as grnNum
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing rm ON rm.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  WHERE i.harvest_type = '${HarvestTypes.Live_Harvest}' and gi.reweighment_status = true `

      query = query + `GROUP BY gi.grn_id`
      const details = await manager.query(query);

      
      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }
  async getQuantityDeviationFarmers(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = ` SELECT gi.farmer,s.name as farmerName
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing rm ON rm.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  WHERE i.harvest_type = '${HarvestTypes.Live_Harvest}' and gi.reweighment_status = true `

      query = query + `GROUP BY gi.farmer`
      const details = await manager.query(query);

      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }

  async getHarvestTypesForQuantityDeviation(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT gi.grn_item_id,gi.indent_id,i.harvest_type
FROM ${appSettings.rm_procure_db}.grn_items gi
LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id=gi.indent_id
GROUP BY i.harvest_type `
      const details = await manager.query(query);

      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }


  async getQuantityDeviationBatches(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = ` SELECT gi.plant_lot_number
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing rm ON rm.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  WHERE i.harvest_type = '${HarvestTypes.Live_Harvest}' and gi.reweighment_status = true `

      query = query + `GROUP BY gi.grn_id`
      const details = await manager.query(query);

      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {
      throw err
    }

  }

  async getPuchareAnalysisReport(req: BatchNumRequest): Promise<Response> {
    try {
      const manager = getManager();
      let lotCodes = []
//       const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
// const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A','R-0320-B'"
const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
const batchData = batchNumArray.map(batch => {
  const parts = batch.split('-'); // Split by '-'
  const year = parts.pop(); // Extract the last part as year
  const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
  return { batchCode, year };
});

const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');

      let query = ` SELECT rma.farmer AS farmerName,rma.harvest_type AS harvestType, rma.lot_number AS batch,rma.vehicle_num AS vehicleNum,
  rma.no_of_creates AS noOfCreate,rma.vehicle_type AS vehicleType,rma.lot_number AS batchNum,
  rma.grn_hon_quantity AS QTY,(rma.inv_rate-5) AS price,rma.supplier_type AS category,rma.plant_unloading_date AS loadingDate,rma.grn_hon_count as count,
  rma.grn_date AS GrnDate,rma.harvest_supervisor AS supervisor1,rma.intake_supervisor AS supervisor2,rma.city,rma.harvest_date AS harvestDate,p.name as product
  FROM ${appSettings.analytics_db}.rm_purchase_analysis rma 
  LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.plant_lot_number = rma.lot_number AND rma.year= gi.year AND gi.is_active = 1
  left join  ${appSettings.masters_db}.products p on p.product_id = gi.product
  WHERE rma.lot_number IN (${formattedBatchCodes}) and rma.year IN(${formattedYears})`
      query = query+` GROUP BY rma.lot_number,rma.year `
  //     const details = await manager.query(query);
//   let query =`SELECT gi.plant_lot_number as batch,
//   gi.updated_at as loadingDate,g.grn_date as GrnDate, SUM(if(gi.reweighment_boxes>0,gi.reweighment_boxes,gi.boxes))AS noOfCreate,
//   s.name as farmerName,s.supplier_category as category,s.city,
//     f.name as dealerName,f.supplier_category as dealerCategory,f.city as dealerCity,
//   emp1.employee_name AS supervisor1,emp2.employee_name AS supervisor2,i.harvest_type as harvestType ,v.vehicle_type as vehicleType,i.supplier_type as supplierType,
//   g.vehicle_number as vehicleNum,gi.lot_number as lotNum,
//   g.grn_id , gi.count ,SUM(gi.quantity) AS QTY,gi.price 
//   FROM `+appSettings.rm_procure_db+`.grn_items gi
//   LEFT JOIN `+appSettings.rm_procure_db+`.grn g ON g.grn_id = gi.grn_id
// LEFT JOIN `+appSettings.masters_db+`.suppliers s ON s.supplier_id = gi.farmer
// LEFT JOIN `+appSettings.rm_procure_db+`.indent i ON i.indent_id = gi.indent_id
// LEFT JOIN `+appSettings.rm_procure_db+`.indent_items ii ON ii.indent_id = i.indent_id
// LEFT JOIN `+appSettings.masters_db+`.suppliers f ON f.supplier_id = ii.broker
 
// LEFT JOIN `+appSettings.transport_db+`.vehicle_assignment v ON v.indent_id = i.indent_id
// LEFT JOIN `+appSettings.rm_procure_db+`.rm_re_weighing re ON re.grn_id = gi.grn_id
// LEFT JOIN `+appSettings.masters_db+`.employee_details emp1 ON emp1.employee_id = i.assign_lead_1
// LEFT JOIN `+appSettings.masters_db+`.employee_details emp2 ON emp2.employee_id = i.assign_lead_2
//   WHERE gi.plant_lot_number = '${req.batchNum}'`
  // query = query+`GROUP BY gi.grn_id`
  const details =await manager.query(query);
      for (const rec of details) {
        lotCodes.push(rec.batch)
      }
      return new Response(true, 1, 'data retrived sucessfully', details, lotCodes)
    } catch (err) {
      throw err
    }

  }

  async getPuchareAnalysisData(req: BatchNumRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
//       const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
// const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A','R-0320-B'"
const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
const batchData = batchNumArray.map(batch => {
  const parts = batch.split('-'); // Split by '-'
  const year = parts.pop(); // Extract the last part as year
  const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
  return { batchCode, year };
});

const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');

      let query = `SELECT rma.grade AS  hlCount, quantity AS hlWeight, rma.rm_rate AS price,rma.hon_quantity as honQty,rma.hon_count as honCount,rma.inv_rate as invRate, rma.grn_rm_rate as grnRmRate FROM ${appSettings.analytics_db}.rm_purchase_analysis rma WHERE 1=1`
      if (req.batchNum != undefined) {
        // const statusString = req.batchNum.map(status => `'${status}'`).join(', ')
        // console.log(req.batchNum.map(status => `'${status}'`), 'ooooooooooooooooooo');

        query = query + ` AND rma.lot_number IN (${formattedBatchCodes}) AND rma.year IN(${formattedYears})`;
      }
      query = query + ` GROUP BY rma.grade`

      const details = await manager.query(query);



      return new CommonResponse(true, 1, 'No data found', details)

    } catch (err) {

      throw err
    }

  }
  async getAllBatchesForReWeighment(req:IdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `
      SELECT 
    GROUP_CONCAT(DISTINCT (lcd.lot_number)) AS batchNo,GROUP_CONCAT(DISTINCT CONCAT(lcd.lot_number, '-', grni.year)) AS yearBatch
FROM ${appSettings.production_db}.lot_code_data lcd
    LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = lcd.indent_no
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items grni ON lcd.lot_number = grni.plant_lot_number and lcd.year = grni.year
    LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = grni.grn_id
    WHERE i.harvest_type = 'Re Weighment' AND grni.inv_status = 'CLOSE'`
     if (req.Id && req.Id != 5) {
      query = query + ' and g.plant_id = ' + req.Id;
        }
        query = query+ ` GROUP BY 
    CASE 
        WHEN lot_club_status = 1 THEN clubbed_main_lot 
        ELSE lcd.lot_number 
END,grni.year`
      const details = await manager.query(query);
      if (query.length) {
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', details)
      } else {
        return new CommonResponse(false, 0, 'No data found', [])
      }

    } catch (err) {
      throw err
    }

  }
  async getAllBatchesForLive(req:IdRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      // let query = `
      // SELECT rma.lot_number as batchNo FROM ${appSettings.analytics_db}.rm_purchase_analysis rma WHERE rma.harvest_type = 'Live Harvest'`

      // query = query + ` GROUP BY rma.lot_number`
      let query = `
      SELECT 
    GROUP_CONCAT(DISTINCT (lcd.lot_number)) AS batchNo,GROUP_CONCAT(DISTINCT CONCAT(lcd.lot_number, '-', grni.year))  AS yearBatch
    FROM ${appSettings.production_db}.lot_code_data lcd
    LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = lcd.indent_no
    LEFT JOIN ${appSettings.rm_procure_db}.grn_items grni ON lcd.lot_number = grni.plant_lot_number and lcd.year = grni.year
        LEFT JOIN ${appSettings.rm_procure_db}.grn g ON g.grn_id = grni.grn_id
    WHERE i.harvest_type = 'Live Harvest' AND grni.inv_status = 'CLOSE' `
      if (req.Id && req.Id != 5) {
      query = query + ' and g.plant_id = ' + req.Id;
        }
        query = query+` GROUP BY 
    CASE 
        WHEN lot_club_status = 1 THEN clubbed_main_lot 
        ELSE lcd.lot_number 
END,grni.year`
      const details = await manager.query(query);
      if (query.length) {
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', details)
      } else {
        return new CommonResponse(false, 0, 'No data found', [])
      }

    } catch (err) {
      throw err
    }

  }
  async getAllBatchesAgainstMainLot(req: BatchNumRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let lotCodes = []
      // const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
      // const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A','R-0320-B'"
      const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
      const batchData = batchNumArray.map(batch => {
        const parts = batch.split('-'); // Split by '-'
        const year = parts.pop(); // Extract the last part as year
        const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
        return { batchCode, year };
      });
      
      const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
      const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');
       
      let query = `SELECT rma.lot_number as batch FROM ${appSettings.analytics_db}.rm_purchase_analysis rma WHERE rma.lot_number IN (${formattedBatchCodes})  AND rma.year IN(${formattedYears})`

      const details = await manager.query(query);
      for (const rec of details) {
        lotCodes.push(rec.batch)
      }
      if (query.length) {
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', lotCodes)
      } else {
        return new CommonResponse(false, 0, 'No data found', [])
      }

    } catch (err) {
      throw err
    }

  }
  async getRmPriceByCount(req: RmCountRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
//       let query = `  SELECT rm.price,rm.count FROM ` + appSettings.rm_procure_db + `.rm_rates rm WHERE rm.count IN (${req.count1},${req.count2}) AND rm.category = '${CompanyCategoryEnum.OWN}'`
// query = query + `GROUP BY rm.count`
//  let query = `SELECT 
//     COALESCE(
//       (SELECT price 
//        FROM ${appSettings.rm_procure_db}.rm_rates rm
//        WHERE count IN (${req.count1}, ${req.count2})
//          AND category = '${CompanyCategoryEnum.OWN}'
//          AND type = '${req.harvestType}'
//          AND DATE(rm.created_at) = '${req.date}'
//        LIMIT 1),
//       (SELECT rl.price 
//        FROM ${appSettings.rm_procure_db}.rm_rates_logs rl
//        JOIN ${appSettings.rm_procure_db}.rm_rates rm 
//          ON rl.rm_rates_id = rm.rm_rates_id
//        WHERE rl.count IN (${req.count1}, ${req.count2})
//          AND rm.category = '${CompanyCategoryEnum.OWN}'
//          AND rm.type = '${req.harvestType}'
//          AND DATE('${req.date}') BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date)
//        ORDER BY rl.effective_from DESC
//        LIMIT 1),
//       (SELECT rm.price 
//        FROM ${appSettings.rm_procure_db}.rm_rates rm
//        WHERE rm.count IN (${req.count1}, ${req.count2})
//          AND rm.category = '${CompanyCategoryEnum.OWN}'
//          AND rm.type = '${req.harvestType}'
//        ORDER BY rm.created_at DESC
//        LIMIT 1)
//     ) AS price,
//     rm.count
//   FROM 
//     ${appSettings.rm_procure_db}.rm_rates rm
//   WHERE 
//     count IN (${req.count1}, ${req.count2})
//     AND category = '${CompanyCategoryEnum.OWN}'
//     AND type = '${req.harvestType}'
//   GROUP BY count;
// `;
let  query = `  SELECT
        rl.count,
    MAX(CASE WHEN TYPE = 'Re Weighment' THEN rl.price ELSE 0 END) AS price
      FROM
        ${appSettings.rm_procure_db}.rm_rates_logs rl
        LEFT JOIN ${appSettings.rm_procure_db}.rm_rates r ON r.rm_rates_id = rl.rm_rates_id
      WHERE 
      rl.count IN (${req.count1}, ${req.count2})
      AND r.category = '${CompanyCategoryEnum.OWN}'
      AND r.type = '${req.harvestType}'
      AND DATE('${req.date}') BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date)
      GROUP BY rl.count
      ORDER BY rl.count,rl.effective_from DESC`;

      let details = await manager.query(query);
      if (!details || details.length === 0) {
        console.log(details.length);
        
        query = `
        SELECT
          count, MAX(CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS price
               FROM
          ${appSettings.rm_procure_db}.rm_rates r
      WHERE r.count IN (${req.count1}, ${req.count2})
      AND r.category = '${CompanyCategoryEnum.OWN}'
      AND r.type = '${req.harvestType}'
         
  GROUP BY
          r.count;
      `;
       
        details = await manager.query(query);
      }
      if (query.length) {
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', details)
      } else {
        return new CommonResponse(false, 0, 'No data found', [])
      }

    } catch (err) {
      throw err
    }

  }
  async getLivePurchase(req: BatchNumRequest): Promise<CommonResponse> {
    try {
      console.log(req,'uuuuuuuuuu');
      
      const manager = getManager();
      const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
      const batchData = batchNumArray.map(batch => {
        const parts = batch.split('-'); // Split by '-'
        const year = parts.pop(); // Extract the last part as year
        const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
        return { batchCode, year };
      });
  
      const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
      const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');
  
        let query = `SELECT SUM(rm.reweighment_quantity) as qty,rm.grn_item_id,rm.count AS grnCount,SUM(rm.quantity) AS quantity,rm.reweighment_count as count,ri.unit_price as price,i.commission  FROM ` + appSettings.rm_procure_db + `.grn_items rm
    LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = rm.grn_id
    LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = rm.grn_item_id
    LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = rm.indent_id
    WHERE 1=1 `
    // const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
    //   const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A',
    // if (req.lotNum != undefined || (req.lotNum).length > 0) {
    //   const statusString = req.lotNum.map(status => `'${status}'`).join(', ')
    //   query = query + ` AND rm.plant_lot_number IN (${statusString})`;
    // }
    if (req.batchNum != undefined || (req.batchNum).length > 0) {
      // const statusString = req.lotNum.map(status => `'${status}'`).join(', ')
      query = query + ` AND rm.plant_lot_number IN (${formattedBatchCodes}) AND rm.year IN(${formattedYears})`;
    }
     query = query + ` GROUP BY rm.count`
      const details = await manager.query(query);
      if (query.length) {
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', details)
      } else {
        return new CommonResponse(false, 0, 'No data found', [])
      }

    } catch (err) {
      throw err
    }

  }

  async getRmRecievingReportData(req: RmReceivingReportReq): Promise<CommonResponse> {
    try {
      const manager = getManager();

      let farmers = `SELECT ri.batch_number,g.reweighment_date,g.grn_id,
  ri.unit_price as rm_rate,gi.ice_rate,ri.count AS count,ri.quantity AS quantity,gi.remarks,gi.grn_item_id,d.defect_name as defect,gid.quantity as defectQty,
  f.name,f.city,f.state,i.commission,ri.total_amount as amount, 
  i.farm_type,i.assign_lead_1,i.supplier_type,i.farm_type,i.indent_id,emp.employee_name,i.harvest_type,g.supervisor_id,
  CONCAT(ed.employee_name,".",ed.emp_last_name) AS supervisorName ,ri.bill_to,ri.bill_to_type AS billType,ri.financier_name AS financier,fi.name AS financierFarmer,DATE(i.indent_date) as indentDate,p.name as product
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.employee_details emp  ON emp.employee_id = i.assign_lead_1
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id

  LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.grn_item__defects_id = ri.defect_id 
    LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id    
     LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id=g.supervisor_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers fi ON fi.supplier_id = ri.bill_to
  LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=gi.product

  WHERE i.supplier_type = '${SupplierTypeEnum.FARMER}'
   AND (i.farm_type IS NULL OR i.farm_type != '${FarmTypesEnum.OWN}') AND gi.reweighment_status = 1 AND gi.inv_status = 'CLOSE'
    AND DATE(gi.reweighment_date) = '${req.grnDate}' `
   if (req.unitId && req.unitId != 5) {
      farmers = farmers + ' and g.plant_id = ' + req.unitId;
        }
    farmers = farmers +` GROUP BY ri.batch_number,ri.count,ri.defect_id`
      let agents = `  SELECT ri.batch_number,g.reweighment_date,g.grn_id,
  ri.unit_price as rm_rate,gi.ice_rate,ri.count AS count,ri.quantity AS quantity,gi.remarks,gi.grn_item_id,d.defect_name as defect,gid.quantity as defectQty,
  f.name,f.city,f.state,i.commission,ri.total_amount as amount,
  i.farm_type,i.assign_lead_1,i.supplier_type,i.farm_type,i.indent_id,emp.employee_name,i.harvest_type,g.supervisor_id,
  CONCAT(ed.employee_name,".",ed.emp_last_name) AS supervisorName ,ri.bill_to,ri.bill_to_type AS billType,ri.financier_name AS financier,fi.name AS financierFarmer,DATE(i.indent_date) as indentDate,p.name as product
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
    LEFT JOIN `+ appSettings.masters_db + `.employee_details emp  ON emp.employee_id = i.assign_lead_1
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id  
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.grn_item__defects_id = ri.defect_id 
    LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id    
     LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id=g.supervisor_id 
  LEFT JOIN `+ appSettings.masters_db + `.suppliers fi ON fi.supplier_id = ri.bill_to
  LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=gi.product

  WHERE i.supplier_type = '${SupplierTypeEnum.AGENT}'
   AND (i.farm_type IS NULL OR i.farm_type != '${FarmTypesEnum.OWN}')AND gi.reweighment_status = 1 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'
    AND DATE(gi.reweighment_date) = '${req.grnDate}'`
 if (req.unitId && req.unitId != 5) {
      agents = agents + ' and g.plant_id = ' + req.unitId;
        }
    agents = agents +` GROUP BY ri.batch_number,ri.count,ri.defect_id`
    
      let apDealers = `SELECT ri.batch_number,g.reweighment_date,g.grn_id,
  ri.unit_price as rm_rate,gi.ice_rate,ri.count AS count,ri.quantity AS quantity,gi.remarks,gi.grn_item_id,d.defect_name as defect,gid.quantity as defectQty,
  f.name,f.city,f.state,i.commission,ri.total_amount as amount,
  i.farm_type,i.assign_lead_1,i.supplier_type,i.farm_type,i.indent_id,emp.employee_name,i.harvest_type,g.supervisor_id,
  CONCAT(ed.employee_name,".",ed.emp_last_name) AS supervisorName ,ri.bill_to,ri.bill_to_type AS billType,ri.financier_name AS financier,fi.name AS financierFarmer,DATE(i.indent_date) as indentDate,p.name as product
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.employee_details emp  ON emp.employee_id = i.assign_lead_1
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii ON ii.indent_id =i.indent_id
    LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = ii.broker
    LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.grn_item__defects_id = ri.defect_id 
  LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id    
  LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id=g.supervisor_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers fi ON fi.supplier_id = ri.bill_to
  LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=gi.product

  WHERE i.supplier_type = '${SupplierTypeEnum.DEALER}'
   AND (i.farm_type IS NULL OR i.farm_type != '${FarmTypesEnum.OWN}')
    AND DATE(gi.reweighment_date) = '${req.grnDate}' AND gi.reweighment_status = 1 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'
    AND f.state = 'ANDHRA PRADESH'`
 if (req.unitId && req.unitId != 5) {
      apDealers = apDealers + ' and g.plant_id = ' + req.unitId;
        }
    apDealers = apDealers +` GROUP BY ri.batch_number,ri.count,ri.defect_id`
    
      let otherDealears = ` SELECT ri.batch_number,g.reweighment_date,g.grn_id,
  ri.unit_price as rm_rate,gi.ice_rate,ri.count AS count,ri.quantity AS quantity,gi.remarks,gi.grn_item_id,d.defect_name as defect,gid.quantity as defectQty,
  f.name,f.city,f.state,i.commission,ri.total_amount as amount,
  i.farm_type,i.assign_lead_1,i.supplier_type,i.farm_type,i.indent_id,emp.employee_name,i.harvest_type,g.supervisor_id,
  CONCAT(ed.employee_name,".",ed.emp_last_name) AS supervisorName ,ri.bill_to,ri.bill_to_type AS billType,ri.financier_name AS financier,fi.name AS financierFarmer,DATE(i.indent_date) as indentDate,p.name as product
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.employee_details emp  ON emp.employee_id = i.assign_lead_1
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii ON ii.indent_id =i.indent_id
    LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = ii.broker
    LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id
    LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.defect_id = ri.defect_id
    LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.grn_item__defects_id    
     LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id=g.supervisor_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers fi ON fi.supplier_id = ri.bill_to
  LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=gi.product

  WHERE i.supplier_type = '${SupplierTypeEnum.DEALER}'
   AND i.farm_type = '${FarmTypesEnum.OTHERS}'
    AND DATE(gi.reweighment_date) = '${req.grnDate}' AND gi.reweighment_status = 1 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'
    AND f.state != 'ANDHRA PRADESH'`
if (req.unitId && req.unitId != 5) {
      otherDealears = otherDealears + ' and g.plant_id = ' + req.unitId;
        }
    otherDealears = otherDealears +` GROUP BY ri.batch_number,ri.count,ri.defect_id`
   
      let ownFarmers = ` SELECT ri.batch_number,g.reweighment_date,g.grn_id,
  ri.unit_price as rm_rate,gi.ice_rate,ri.count AS count,ri.quantity AS quantity,gi.remarks,gi.grn_item_id,d.defect_name as defect,gid.quantity as defectQty,
  f.name,f.city,f.state,i.commission,ri.total_amount as amount,
  i.farm_type,i.assign_lead_1,i.supplier_type,i.farm_type,i.indent_id,emp.employee_name,i.harvest_type,g.supervisor_id,
  CONCAT(ed.employee_name,".",ed.emp_last_name) AS supervisorName ,ri.bill_to,ri.bill_to_type AS billType,ri.financier_name AS financier,fi.name AS financierFarmer,DATE(i.indent_date) as indentDate,p.name as product
  FROM `+ appSettings.rm_procure_db + `.grn_items gi
  LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = gi.farmer
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
  LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = gi.indent_id
  LEFT JOIN `+ appSettings.masters_db + `.employee_details emp  ON emp.employee_id = i.assign_lead_1
  LEFT JOIN `+ appSettings.rm_procure_db + `.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id  
  LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.grn_item__defects_id = ri.defect_id 
    LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id    
  LEFT JOIN `+ appSettings.masters_db + `.employee_details ed ON ed.employee_id=g.supervisor_id
  LEFT JOIN `+ appSettings.masters_db + `.suppliers fi ON fi.supplier_id = ri.bill_to
  LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=gi.product

  WHERE i.farm_type = '${FarmTypesEnum.OWN}' AND gi.reweighment_status = 1 AND gi.inv_status = '${InvoiceStatusEnum.CLOSE}'
    AND DATE(gi.reweighment_date) = '${req.grnDate}' 
       `
        if (req.unitId && req.unitId != 5) {
      ownFarmers = ownFarmers + ' and g.plant_id = ' + req.unitId;
        }
    ownFarmers = ownFarmers +` GROUP BY ri.batch_number,ri.count,ri.defect_id`
   
      const farmersData = await manager.query(farmers);
      const agentsData = await manager.query(agents);
      const apDealersData = await manager.query(apDealers);
      const otherDealearsData = await manager.query(otherDealears);
      const ownFarmersData = await manager.query(ownFarmers);

      let farmerData: RmReceivingDataModel[] = []
      let agentData: RmReceivingDataModel[] = []
      let apDealerData: RmReceivingDataModel[] = []
      let otherDealearData: RmReceivingDataModel[] = []
      let ownFarmerData: RmReceivingDataModel[] = []

      if (farmersData.length > 0) {
        for (const res of farmersData) {
          const val = new RmReceivingDataModel(res.grn_item_id,res.batch_number, res.name, res.city, res.count, res.quantity, res.rm_rate, res.ice_rate, res.remarks, res.harvest_type, res.supervisorName,res.defect,res.defectQty,res.amount,res.commission,res.billType === 'Financier' ? res.financier:res.financierFarmer,res.billType,res.indentDate,res.product)
          farmerData.push(val)
        }
      }
      if (agentsData.length > 0) {
        for (const res of agentsData) {
          const val = new RmReceivingDataModel(res.grn_item_id,res.batch_number, res.name, res.city, res.count, res.quantity, res.rm_rate, res.ice_rate, res.remarks, res.harvest_type, res.supervisorName,res.defect,res.defectQty,res.amount,res.commission,res.billType === 'Financier' ? res.financier:res.financierFarmer,res.billType,res.indentDate,res.product)
          agentData.push(val)
        }
      }
      // console.log(agentData,'aaaaaaaaaaa');
      
      if (apDealersData.length > 0) {
        for (const res of apDealersData) {
          const val = new RmReceivingDataModel(res.grn_item_id,res.batch_number, res.name, res.city, res.count, res.quantity, res.rm_rate, res.ice_rate, res.remarks, res.harvest_type, res.supervisorName,res.defect,res.defectQty,res.amount,res.commission,res.billType === 'Financier' ? res.financier:res.financierFarmer,res.billType,res.indentDate,res.product)
          apDealerData.push(val)
        }
      }
      if (otherDealearsData.length > 0) {
        for (const res of otherDealearsData) {
          const val = new RmReceivingDataModel(res.grn_item_id,res.batch_number, res.name, res.city, res.count, res.quantity, res.rm_rate, res.ice_rate, res.remarks, res.harvest_type, res.supervisorName,res.defect,res.defectQty,res.amount,res.commission,res.billType === 'Financier' ? res.financier:res.financierFarmer,res.billType,res.indentDate,res.product)
          otherDealearData.push(val)
        }
      }
      if (ownFarmersData.length > 0) {
        for (const res of ownFarmersData) {
          const val = new RmReceivingDataModel(res.grn_item_id,res.batch_number, res.name, res.city, res.count, res.quantity, res.rm_rate, res.ice_rate, res.remarks, res.harvest_type, res.supervisorName,res.defect,res.defectQty,res.amount,res.commission,res.billType === 'Financier' ? res.financier:res.financierFarmer,res.billType,res.indentDate,res.product)
          ownFarmerData.push(val)
        }
      }
     
      
      if (farmersData.length > 0 || agentsData.length > 0 || apDealersData.length > 0 || otherDealearData.length > 0 || ownFarmersData.length > 0) {
        const data = new RmReceivingReportModel(req.grnDate, farmerData, agentData, apDealerData, otherDealearData, ownFarmerData)
        return new CommonResponse(true, 1, ' Data retrived Sucessfully', data)

      } else {
        return new CommonResponse(false, 0, ' No Data Found', [])
      }

    }


    catch (err) {
      throw err
    }

  }

//   async getRmRecievingReportSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
//     try {
//       let results1
//       const manager = getManager();
//       const startDate = new Date(req.grnDate) //(13/12)
//       // console.log(moment(datee).format('DD-MM-YYYY'), 'oooooooooooooooooooooo');
//       // console.log((datee.getMonth() + 1), 'iiiiiiiiiiiii');
//       // console.log(new Date(startDate.setDate(startDate.getDate() - 11)),'dateeeee');
//       // const targetMonth1 = startDate.getMonth(); 
//       // console.log(startDate,'oooooooooooo');
//       const targetMonth = startDate.getMonth() ; 
//       // console.log(startDate.getMonth()+1 ,'ttttttttttttt');
      
//       const targetYear = startDate.getFullYear();
//       // console.log(targetYear,'yrrrrrrrrrrrrrrr');
      
//       const datee = new Date(startDate.setDate(startDate.getDate() - 11));// (2/12)
//       // console.log(date,date.getMonth()+1,'beforeeeeeeeeeee');
//       // console.log(new Date(req.grnDate).getMonth()+1, date.getMonth()+1,startDate.getMonth()+1 !== date.getMonth()+1,'verifyyyyyyyyy');
      
//   //     let datee
//   //     if(new Date(req.grnDate).getMonth() != date.getMonth() ){
//   //       console.log('not equalllllllll');
        
//   // datee =new Date(new Date(req.grnDate).getFullYear(), new Date(req.grnDate).getMonth(), 1); 
//   //     }else{
//   //       console.log('equalllllllll');
        
//   //       datee = date
//   //     }
//   //     console.log(datee.getDate(),'start date');
      
//       // const targetYear1 = startDate.getFullYear();
//       const monthNames = [
//         "January", "February", "March", "April", "May", "June",
//         "July", "August", "September", "October", "November", "December"
//         ];
//         const monthName = monthNames[targetMonth];
//         // const monthName1 = monthNames[targetMonth1];

//         // console.log(monthName,'monthhhhhhhhhhhhh');
//       const startDateOfMonth = new Date(targetYear, targetMonth, 1); 
//       const endDateOfMonth = new Date(targetYear, targetMonth, 0); 
//       console.log(startDateOfMonth,'startDateOfMonth');
      
//       const formattedStartDate = moment(startDateOfMonth).format('YYYY-MM-DD');
//       console.log(formattedStartDate,'formattedStartDate');
      
//       const formattedEndDate = moment(req.grnDate).format('YYYY-MM-DD');
//       console.log(formattedEndDate,'formattedEndDate');

// // console.log(moment(new Date(datee.setDate(datee.getDate() + 2))).format('YYYY-MM-DD'),'ppppppppppppppppppp');

//       // Calculate next 6 dates after formattedEndDate using Moment.js add method
//       let nextDate1 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate2 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate3 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate4 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate5 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate6 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate7 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate8 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate9 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');
//       let nextDate10 =moment(new Date(datee.setDate(datee.getDate() + 1))).format('YYYY-MM-DD');

// // console.log(nextDate1,nextDate2,nextDate3,nextDate4,'dateeeeeeeeeeeee');

//             // let dateValue
//       let allquery = `SELECT 
//     r.count,r.quantity AS rmQty,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN  ri.quantity ELSE 0 END)AS opBal,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate1}' THEN  ri.quantity ELSE 0 END)AS day1,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate2}' THEN  ri.quantity ELSE 0 END)AS day2,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate3}' THEN  ri.quantity ELSE 0 END)AS day3,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate4}' THEN  ri.quantity ELSE 0 END)AS day4,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate5}' THEN  ri.quantity ELSE 0 END)AS day5,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate6}' THEN  ri.quantity ELSE 0 END)AS day6,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate7}' THEN  ri.quantity ELSE 0 END)AS day7,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate8}' THEN  ri.quantity ELSE 0 END)AS day8,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate9}' THEN  ri.quantity ELSE 0 END)AS day9,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate10}' THEN  ri.quantity ELSE 0 END)AS day10,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS selectedDate,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS total
// FROM 
//     ${appSettings.masters_db}.rm_budget r
//     LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
//         ON CAST(ri.count AS UNSIGNED) BETWEEN 
//            CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED) 
//            AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) AND r.month ='${monthName}'
//     LEFT JOIN ${appSettings.rm_procure_db}.grn g 
//         ON ri.grn_id = g.grn_id 
//         LEFT JOIN (SELECT 
//         indent_id, 
//         product 
//     FROM ${appSettings.rm_procure_db}.indent_items
//     GROUP BY indent_id, product) ii ON ii.indent_id = ri.indent_id
// WHERE   r.year='${targetYear}' AND r.count NOT REGEXP '[A-Za-z]' AND ii.product != 1 `
// allquery +=  ` GROUP BY r.count`
//     let othersQuerry = `SELECT 
//     r.count,r.quantity AS rmQty,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN  ri.quantity ELSE 0 END)AS opBal,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate1}' THEN  ri.quantity ELSE 0 END)AS day1,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate2}' THEN  ri.quantity ELSE 0 END)AS day2,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate3}' THEN  ri.quantity ELSE 0 END)AS day3,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate4}' THEN  ri.quantity ELSE 0 END)AS day4,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate5}' THEN  ri.quantity ELSE 0 END)AS day5,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate6}' THEN  ri.quantity ELSE 0 END)AS day6,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate7}' THEN  ri.quantity ELSE 0 END)AS day7,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate8}' THEN  ri.quantity ELSE 0 END)AS day8,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate9}' THEN  ri.quantity ELSE 0 END)AS day9,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate10}' THEN  ri.quantity ELSE 0 END)AS day10,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS selectedDate,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS total
// FROM 
//     ${appSettings.rm_procure_db}.rm_invoice ri
//     LEFT JOIN ${appSettings.masters_db}.rm_budget r
//         ON CAST(ri.count AS UNSIGNED) BETWEEN
//            CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)
//            AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) and  r.month = '${monthName}'
          
// LEFT JOIN ${appSettings.rm_procure_db}.grn g 
//         ON ri.grn_id = g.grn_id 
//       LEFT JOIN (SELECT 
//         indent_id, 
//         product 
//     FROM ${appSettings.rm_procure_db}.indent_items
//     GROUP BY indent_id, product) ii ON ii.indent_id = ri.indent_id
//     WHERE r.count IS NULL AND ii.product != 1`
// let blackTigerQuerry =`SELECT 
//     p.name as count,r.quantity AS rmQty,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN  ri.quantity ELSE 0 END)AS opBal,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate1}' THEN  ri.quantity ELSE 0 END)AS day1,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate2}' THEN  ri.quantity ELSE 0 END)AS day2,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate3}' THEN  ri.quantity ELSE 0 END)AS day3,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate4}' THEN  ri.quantity ELSE 0 END)AS day4,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate5}' THEN  ri.quantity ELSE 0 END)AS day5,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate6}' THEN  ri.quantity ELSE 0 END)AS day6,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate7}' THEN  ri.quantity ELSE 0 END)AS day7,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate8}' THEN  ri.quantity ELSE 0 END)AS day8,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate9}' THEN  ri.quantity ELSE 0 END)AS day9,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${nextDate10}' THEN  ri.quantity ELSE 0 END)AS day10,
//     SUM(CASE WHEN  DATE(gi.reweighment_date)='${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS selectedDate,
//     SUM(CASE WHEN  DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${moment(req.grnDate).format('YYYY-MM-DD')}' THEN  ri.quantity ELSE 0 END)AS total
// FROM 
//     ${appSettings.rm_procure_db}.rm_invoice ri
//     LEFT JOIN ${appSettings.masters_db}.rm_budget r
//         ON CAST(ri.count AS UNSIGNED) BETWEEN
//            CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)
//            AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) and r.month ='${monthName}'
// LEFT JOIN ${appSettings.rm_procure_db}.grn g 
//         ON ri.grn_id = g.grn_id 
//         LEFT JOIN (SELECT 
//         indent_id, 
//         product 
//     FROM ${appSettings.rm_procure_db}.indent_items
//     GROUP BY indent_id, product) ii ON ii.indent_id = ri.indent_id
//             LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id = ii.product
// WHERE ii.product = 1`
// let query =`${allquery} UNION ALL ${othersQuerry} UNION ALL ${blackTigerQuerry}`
//       const results = await manager.query(query);
//       let dates =[
//         {date:nextDate1},
//         {date:nextDate2},
//         {date:nextDate3},
//         {date:nextDate4},
//         {date:nextDate5},
//         {date:nextDate6},
//         {date:nextDate7},
//         {date:nextDate8},
//         {date:nextDate9},
//         {date:nextDate10}
//       ]
//       // ------------before 7days from selected date-----------------------------
//       // let query = `SELECT gi.count,SUM(quantity) as quantity FROM ` + appSettings.rm_procure_db + `.grn_items gi
//       // LEFT JOIN ` + appSettings.rm_procure_db + `.grn g ON gi.grn_id = gi.grn_id
//       // WHERE  DATE(g.grn_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
//       // GROUP BY gi.count`
//       // const results = await manager.query(query);
//       // // ---------------rm count range querry--------------------
//       // let rmQuery = `SELECT r.count, r.quantity,r.year FROM ` + appSettings.masters_db + `.rm_budget r
//       // WHERE  r.month = '${monthName}' AND r.year = '${targetYear}'
//       // GROUP BY r.count`
//       // const rmResults = await manager.query(rmQuery);
//       // let responseData = [];
//       //   // --------------upto till date---------------
//       // for (let i = 0; i < 7; i++) {
//       //   console.log(i,'ppppppppppppppppp');
        
//       //   dateValue = new Date(datee.setDate(datee.getDate() + 1))
//       //   console.log(dateValue,'dateeeeeeeeeeee');
        
//       //   const reqDate = moment(dateValue).format("YYYY-MM-DD")
//       //   let query1 = `SELECT gi.count,SUM(quantity) as quantity,DATE(g.grn_date) as grn_date FROM ` + appSettings.rm_procure_db + `.grn_items gi
//       // LEFT JOIN ` + appSettings.rm_procure_db + `.grn g ON gi.grn_id = gi.grn_id
//       // WHERE  DATE(g.grn_date) ='${reqDate}'
//       // GROUP BY gi.count`

//       //   results1 = await manager.query(query1);
//       //   console.log(results1,'sssssssssssssssssssssss');
        
//       //   // interface QtyInfoModel {
//       //   //   count: string;
//       //   //   qty: number;
//       //   //   date: string
//       //   // }

//       //   // let qtyInfo: QtyInfoModel[] = [];
//       //   // let prevCount: string;
//       //   // let prevQty: number = 0;
//       //   // let countVal: string;
//       //   // let sameCounts: number[] = [];
//       //   // // let colorVal: boolean;
//       //   // let prevDate: string;

//       //   // if (results1) {
//       //   //   for (const priceRec of results1) {

//       //   //     if (prevQty === priceRec.quantity && priceRec.grn_date === prevDate) {
//       //   //       sameCounts.push(parseInt(prevCount));
//       //   //       countVal = Math.min(...sameCounts) + '-' + priceRec.count;
//       //   //       qtyInfo.splice(-1);
//       //   //       // colorVal = true;
//       //   //     } else {
//       //   //       sameCounts = [];
//       //   //       countVal = priceRec.count;
//       //   //       // colorVal = false;
//       //   //     }
//       //   //     qtyInfo.push({ count: countVal, qty: priceRec.quantity, date: moment(priceRec.grn_date).format("YYYY-MM-DD") });
//       //   //     prevCount = priceRec.count;
//       //   //     prevQty = priceRec.quantity;
//       //   //     prevDate = priceRec.grn_date;
//       //   //   }

//       //   //   // console.log(qtyInfo);

//       //   //   if (qtyInfo.length > 0) {
//       //   //     const resultMap = new Map<string, { count: string; qty: number }[]>();
//         //     for (const result of qtyInfo) {
//         //       const { count, qty, date } = result;
//         //       if (!resultMap.has(date)) {
//         //         resultMap.set(date, []);
//         //       }
//         //       resultMap.get(date).push({ count, qty });
//         //     }

//         //     for (const [Date, data] of resultMap.entries()) {
//         //       responseData.push({ Date, data });
//         //     }


//         //   }
//         //   return new CommonResponse(false, 0, 'No data found', [])
//         // }
//       // }
//       if (results.length > 0) {
//         return new Response(true, 1, 'Data retrieved successfully', results,dates);
//       } else {
//         return new Response(false, 0, 'No data found', [],[]);
//       }




//     } catch (err) {
//       throw err
//     }

//   }
async getRmRecievingReportSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
  try {
      const manager = getManager();
      const grnDate = moment(req.grnDate); // Use moment from the start
      const targetMonth = grnDate.month();
      const targetYear = grnDate.year();
      const startingDate = moment({ year: targetYear, month: targetMonth, day: 1 })
      const formattedStartDate = startingDate.format('YYYY-MM-DD');
      const formattedEndDate = grnDate.format('YYYY-MM-DD');

          let startDate = grnDate.clone().subtract(10, 'days');


      const nextDates = [];
      let dates = []
      let currentDate = startDate.clone();
      let datesToAdd = 0; 
      // let formattedStartDate 
      if(startDate.month() === targetMonth){
          datesToAdd = 10;
      }else{
        const startOfMonth = moment({ year: targetYear, month: targetMonth, day: 1 });
    datesToAdd = grnDate.diff(startOfMonth, 'days') + 1; 
        }

      for (let i = 0; i < datesToAdd; i++) {
        if (currentDate.month() !== targetMonth) {
          if(startingDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')){

            nextDates.push(startingDate.format('YYYY-MM-DD'));
            dates.push({ date: startingDate.format('YYYY-MM-DD') });
          }
            // Case: When the current month is different from the target month
            startingDate.add(1, 'day');
        } else {
            // Case: When the current month matches the target month
            if (startDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
                nextDates.push(startDate.format('YYYY-MM-DD'));
                dates.push({ date: startDate.format('YYYY-MM-DD') });
            }
            startDate.add(1, 'day');
        }
    }
      console.log(dates,'pppppppppp');
      
      let opBalEndDate;
      if (datesToAdd > 0) {
         opBalEndDate = grnDate.clone().subtract(datesToAdd + 1, 'days');
          if (opBalEndDate.month() !== targetMonth) {
              opBalEndDate = null; // Set to null if not in the same month, which will result in 0 in query
          }
      } else {
          opBalEndDate = null;
      }
      
      let opBalFormattedEndDate = opBalEndDate ? opBalEndDate.format('YYYY-MM-DD') : null;
      const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
      ];
      const monthName = monthNames[targetMonth];
 let dateSumCases = nextDates.filter(date => date !== formattedEndDate)
    .map((date, index) => `SUM(CASE WHEN DATE(gi.reweighment_date)='${date}' THEN ri.quantity ELSE 0 END) AS day${index + 1}`)
    .join(', '); // Join clauses with a comma and space

// Construct the opBalCondition
const opBalCondition =
    dates[0]?.date === formattedStartDate
        ? '0'
        : `SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND ${opBalFormattedEndDate ? `'${opBalFormattedEndDate}'` : 'NULL'} THEN ri.quantity ELSE 0 END)`;
        // const hasSequenceRanges = await manager.query(`
        //     SELECT COUNT(*) as count
        //     FROM ${appSettings.masters_db}.rm_budget
        //     WHERE year = '${targetYear}' AND month = '${monthName}' AND count LIKE '%-%'
        // `);
    
        // const shouldSubtractOne = hasSequenceRanges[0].count === 0;
    
      //    const baseQuery = (whereClause: string) => `
      //     SELECT 
      //         r.count, r.quantity AS rmQty,
      //                 ${opBalCondition} AS opBal
      //          ${dateSumCases ? `, ${dateSumCases}` : ''},
      //         SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
      //         SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
      //     FROM 
      //         ${appSettings.masters_db}.rm_budget r
      //     LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
      //         ON CAST(ri.count AS UNSIGNED) BETWEEN CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED) AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) AND r.month ='${monthName}'
      //     LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON ri.grn_item_id = gi.grn_item_id
      //     LEFT JOIN (SELECT indent_id, product FROM ${appSettings.rm_procure_db}.indent_items GROUP BY indent_id, product) ii ON ii.indent_id = ri.indent_id
      //     WHERE r.year='${targetYear}' AND ${whereClause} AND ii.product != 1 
      // `;
      let baseQuery = `
      SELECT 
          r.count, r.quantity AS rmQty,
                  ${opBalCondition} AS opBal
           ${dateSumCases ? `, ${dateSumCases}` : ''},
          SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
          SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
      FROM 
          ${appSettings.masters_db}.rm_budget r
          LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON r.count = gi.budget_range
      LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri ON ri.grn_item_id = gi.grn_item_id 
      left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id
      WHERE r.year='${targetYear}'AND r.month ='${monthName}' 
  `;
      let othersQuerry = `SELECT 'OTHERS' AS COUNT, NULL AS rmQty,
      ${opBalCondition} AS opBal
       ${dateSumCases ? `, ${dateSumCases}` : ''},
      SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
      SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
  FROM ${appSettings.rm_procure_db}.rm_invoice ri
  LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON ri.grn_item_id = gi.grn_item_id
        left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id
  WHERE gi.budget_range ='Others'
  AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
  GROUP BY 'OTHERS'`;
  if (req.unitId && req.unitId != 5) {
  baseQuery=baseQuery+`and g.plant_id=${req.unitId}`
  }
  if (req.unitId && req.unitId != 5) {
  othersQuerry=othersQuerry+`and g.plant_id=${req.unitId}`
  }
  othersQuerry=othersQuerry+` GROUP BY 'OTHERS'`
      const allquery = baseQuery+` GROUP BY r.count`;
      // const other = baseQuery(`r.count IS NULL`);
//       const blackTigerQuerry = `
//     SELECT 
//         p.name AS count, 
//         r.quantity AS rmQty,
//         ${opBalCondition} AS opBal,
//         ${dateSumCases ? `${dateSumCases}` : ''} 
//         ${dateSumCases ? ',' : ''} 
//         SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//         SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//     FROM 
//         ${appSettings.rm_procure_db}.rm_invoice ri
//     LEFT JOIN ${appSettings.masters_db}.rm_budget r
//         ON CAST(ri.count AS UNSIGNED) BETWEEN
//         CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)
//         AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) AND r.month = '${monthName}'
    
// LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi
//         ON ri.grn_item_id = gi.grn_item_id
//     LEFT JOIN (
//         SELECT indent_id, product 
//         FROM ${appSettings.rm_procure_db}.indent_items
//         GROUP BY indent_id, product
//     ) ii ON ii.indent_id = ri.indent_id
//     LEFT JOIN ${appSettings.masters_db}.products p 
//         ON p.product_id = ii.product
//     WHERE ii.product = 1;
// `;

      


      // let query = `${allquery} UNION ALL ${othersQuerry} UNION ALL ${blackTigerQuerry}`;
      let query = `${allquery} `;

      const results = await manager.query(query);
      const enhancedResults = [];

      if (results.length > 0) {
          return new Response(true, 1, 'Data retrieved successfully', results, dates); // Return the generated dates
      } else {
          return new Response(false, 0, 'No data found', [], []);
      }

  } catch (err) {
      throw err;
  }
}
// async getRmRecievingReportSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
//   try {
//       const manager = getManager();
//       const grnDate = moment(req.grnDate);
//       const targetMonth = grnDate.month();
//       const targetYear = grnDate.year();
//       const startingDate = moment({ year: targetYear, month: targetMonth, day: 1 });
//       const formattedStartDate = startingDate.format('YYYY-MM-DD');
//       const formattedEndDate = grnDate.format('YYYY-MM-DD');

//       let startDate = grnDate.clone().subtract(10, 'days');
//       const nextDates = [];
//       let dates = [];
//       let currentDate = startDate.clone();
//       let datesToAdd = startDate.month() === targetMonth ? 10 : grnDate.diff(startingDate, 'days') + 1;

//       for (let i = 0; i < datesToAdd; i++) {
//           if (currentDate.month() !== targetMonth) {
//               if (startingDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
//                   nextDates.push(startingDate.format('YYYY-MM-DD'));
//                   dates.push({ date: startingDate.format('YYYY-MM-DD') });
//               }
//               startingDate.add(1, 'day');
//           } else {
//               if (startDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
//                   nextDates.push(startDate.format('YYYY-MM-DD'));
//                   dates.push({ date: startDate.format('YYYY-MM-DD') });
//               }
//               startDate.add(1, 'day');
//           }
//       }

//       let opBalEndDate = datesToAdd > 0 ? grnDate.clone().subtract(datesToAdd + 1, 'days') : null;
//       if (opBalEndDate && opBalEndDate.month() !== targetMonth) {
//           opBalEndDate = null;
//       }

//       let opBalFormattedEndDate = opBalEndDate ? opBalEndDate.format('YYYY-MM-DD') : null;
//       const monthNames = ["January", "February", "March", "April", "May", "June",
//           "July", "August", "September", "October", "November", "December"];
//       const monthName = monthNames[targetMonth];

//       let dateSumCases = nextDates.filter(date => date !== formattedEndDate)
//           .map((date, index) => `SUM(CASE WHEN DATE(gi.reweighment_date)='${date}' THEN ri.quantity ELSE 0 END) AS day${index + 1}`)
//           .join(', ');

//       const opBalCondition = dates[0]?.date === formattedStartDate
//           ? '0'
//           : `SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND ${opBalFormattedEndDate ? `'${opBalFormattedEndDate}'` : 'NULL'} THEN ri.quantity ELSE 0 END)`;

//       const baseQuery = (whereClause: string) => `
//           WITH budget_data AS (
//               SELECT 
//                   r.count,
//                   r.quantity,
//                   CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED) AS start_range,
//                   CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) AS end_range,
//                   LEAD(CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)) 
//                   OVER (ORDER BY CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)) AS next_start
//               FROM ${appSettings.masters_db}.rm_budget r
//               WHERE r.year = '${targetYear}' AND r.month = '${monthName}'
//           )
//           SELECT 
//               r.count, 
//               r.quantity AS rmQty,
//               ${opBalCondition} AS opBal
//               ${dateSumCases ? `, ${dateSumCases}` : ''},
//               SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//               SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//           FROM budget_data r
//           LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
//               ON CAST(ri.count AS UNSIGNED) BETWEEN 
//                   r.start_range AND 
//                   CASE 
//                       WHEN r.next_start = r.end_range + 1 THEN r.end_range  
//                       WHEN r.start_range < 73 THEN r.end_range - 1  
//                       ELSE r.end_range
//                   END
//           LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON ri.grn_item_id = gi.grn_item_id
//           LEFT JOIN (
//               SELECT indent_id, product FROM ${appSettings.rm_procure_db}.indent_items GROUP BY indent_id, product
//           ) ii ON ii.indent_id = ri.indent_id
//           WHERE ${whereClause} AND ii.product != 1 
//           GROUP BY r.count;
//       `;

//       const othersQuery = `SELECT 
//     'OTHERS' AS count, 
//     CAST(NULL AS DECIMAL(10,2)) AS rmQty,
//     ${opBalCondition} AS opBal
//     ${dateSumCases ? `, ${dateSumCases}` : ''},
//     SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//     SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
// FROM ${appSettings.rm_procure_db}.rm_invoice ri
// LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi 
//     ON ri.grn_item_id = gi.grn_item_id
// WHERE NOT EXISTS (
//     SELECT 1
//     FROM ${appSettings.masters_db}.rm_budget rb
//     WHERE rb.year = '${targetYear}'
//     AND rb.month = '${monthName}'
//     AND CAST(ri.count AS UNSIGNED) BETWEEN rb.start_range AND rb.end_range
// )
// AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
// GROUP BY count;
// `;

//       const blackTigerQuery = `
//           SELECT 
//               p.name AS count, 
//               r.quantity AS rmQty,
//               ${opBalCondition} AS opBal,
//               ${dateSumCases ? `${dateSumCases}` : ''} 
//               ${dateSumCases ? ',' : ''} 
//               SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//               SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//           FROM ${appSettings.rm_procure_db}.rm_invoice ri
//           LEFT JOIN ${appSettings.masters_db}.rm_budget r
//               ON CAST(ri.count AS UNSIGNED) BETWEEN r.start_range AND r.end_range
//               AND r.month = '${monthName}'
//           LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON ri.grn_item_id = gi.grn_item_id
//           LEFT JOIN (
//               SELECT indent_id, product 
//               FROM ${appSettings.rm_procure_db}.indent_items
//               GROUP BY indent_id, product
//           ) ii ON ii.indent_id = ri.indent_id
//           LEFT JOIN ${appSettings.masters_db}.products p 
//               ON p.product_id = ii.product
//           WHERE ii.product = 1;
//       `;

//       let query = `${baseQuery(`r.count NOT REGEXP '[A-Za-z]'`)} UNION ALL ${othersQuery} UNION ALL ${blackTigerQuery}`;
//       const results = await manager.query(query);

//       return results.length > 0
//           ? new Response(true, 1, 'Data retrieved successfully', results, dates)
//           : new Response(false, 0, 'No data found', [], []);

//   } catch (err) {
//       throw err;
//   }
// }

// async getRmRecievingReportSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
//   try {
//       const manager = getManager();
//       const grnDate = moment(req.grnDate); // Use moment from the start
//       const targetMonth = grnDate.month();
//       const targetYear = grnDate.year();
//       const startingDate = moment({ year: targetYear, month: targetMonth, day: 1 })
//       const formattedStartDate = startingDate.format('YYYY-MM-DD');
//       const formattedEndDate = grnDate.format('YYYY-MM-DD');

//           let startDate = grnDate.clone().subtract(10, 'days');


//       const nextDates = [];
//       let dates = []
//       let currentDate = startDate.clone();
//       let datesToAdd = 0; 
//       // let formattedStartDate 
//       if(startDate.month() === targetMonth){
//           datesToAdd = 10;
//       }else{
//         const startOfMonth = moment({ year: targetYear, month: targetMonth, day: 1 });
//     datesToAdd = grnDate.diff(startOfMonth, 'days') + 1; 
//         }

//       for (let i = 0; i < datesToAdd; i++) {
//         if (currentDate.month() !== targetMonth) {
//           if(startingDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')){

//             nextDates.push(startingDate.format('YYYY-MM-DD'));
//             dates.push({ date: startingDate.format('YYYY-MM-DD') });
//           }
//             // Case: When the current month is different from the target month
//             startingDate.add(1, 'day');
//         } else {
//             // Case: When the current month matches the target month
//             if (startDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
//                 nextDates.push(startDate.format('YYYY-MM-DD'));
//                 dates.push({ date: startDate.format('YYYY-MM-DD') });
//             }
//             startDate.add(1, 'day');
//         }
//     }
//       // console.log(dates,'pppppppppp');
      
//       let opBalEndDate;
//       if (datesToAdd > 0) {
//          opBalEndDate = grnDate.clone().subtract(datesToAdd + 1, 'days');
//           if (opBalEndDate.month() !== targetMonth) {
//               opBalEndDate = null; // Set to null if not in the same month, which will result in 0 in query
//           }
//       } else {
//           opBalEndDate = null;
//       }
      
//       let opBalFormattedEndDate = opBalEndDate ? opBalEndDate.format('YYYY-MM-DD') : null;
//       const monthNames = [
//           "January", "February", "March", "April", "May", "June",
//           "July", "August", "September", "October", "November", "December"
//       ];
//       const monthName = monthNames[targetMonth];
//  let dateSumCases = nextDates.filter(date => date !== formattedEndDate)
//     .map((date, index) => `SUM(CASE WHEN DATE(gi.reweighment_date)='${date}' THEN ri.quantity ELSE 0 END) AS day${index + 1}`)
//     .join(', '); // Join clauses with a comma and space

// // Construct the opBalCondition
// const opBalCondition =
//     dates[0]?.date === formattedStartDate
//         ? '0'
//         : `SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND ${opBalFormattedEndDate ? `'${opBalFormattedEndDate}'` : 'NULL'} THEN ri.quantity ELSE 0 END)`;

//       const baseQuery = (whereClause: string) => `
//           SELECT 
//               r.count, r.quantity AS rmQty,
//                       ${opBalCondition} AS opBal
//                ${dateSumCases ? `, ${dateSumCases}` : ''},
//               SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//               SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//           FROM 
//               ${appSettings.masters_db}.rm_budget r
//           LEFT JOIN ${appSettings.rm_procure_db}.rm_invoice ri 
// ON CAST(ri.count AS UNSIGNED) BETWEEN CAST(SUBSTRING_INDEX(r.count, '-', AS UNSIGNED) AND CAST(SUBSTRING_INDEX(r.count, '-', -1)+1 AS UNSIGNED) AND r.month ='${monthName}'
//           LEFT JOIN ${appSettings.rm_procure_db}.grn g ON ri.grn_id = g.grn_id
//           LEFT JOIN (SELECT indent_id, product FROM ${appSettings.rm_procure_db}.indent_items GROUP BY indent_id, product) ii ON ii.indent_id = ri.indent_id
//           WHERE r.year='${targetYear}' AND ${whereClause} AND ii.product != 1 
//       `;
//       const othersQuerry = `SELECT 'OTHERS' AS COUNT, NULL AS rmQty,
//       ${opBalCondition} AS opBal
//        ${dateSumCases ? `, ${dateSumCases}` : ''},
//       SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//       SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//   FROM ${appSettings.rm_procure_db}.rm_invoice ri
//   LEFT JOIN ${appSettings.rm_procure_db}.grn g ON ri.grn_id = g.grn_id
//   WHERE NOT EXISTS (
//       SELECT 1
//       FROM ${appSettings.masters_db}.rm_budget rb
//       WHERE rb.year = '${targetYear}'
//       AND rb.month = '${monthName}'
//        AND CAST(ri.count AS UNSIGNED) BETWEEN CAST(SUBSTRING_INDEX(rb.count, '-', AS UNSIGNED)
//       AND CAST(SUBSTRING_INDEX(rb.count, '-', -1)+1 AS UNSIGNED)
//   )
//   AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
//   GROUP BY 'OTHERS'`;
  
//       const allquery = baseQuery(`r.count NOT REGEXP '[A-Za-z]'`)+`GROUP BY r.count`;
//       console.log(allquery,'pppppppppppppppp');
      
//       // const other = baseQuery(`r.count IS NULL`);
//       const blackTigerQuerry = `
//     SELECT 
//         p.name AS count, 
//         r.quantity AS rmQty,
//         ${opBalCondition} AS opBal,
//         ${dateSumCases ? `${dateSumCases}` : ''} 
//         ${dateSumCases ? ',' : ''} 
//         SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//         SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//     FROM 
//         ${appSettings.rm_procure_db}.rm_invoice ri
//     LEFT JOIN ${appSettings.masters_db}.rm_budget r
//         ON CAST(ri.count AS UNSIGNED) BETWEEN
//         CAST(SUBSTRING_INDEX(r.count, '-', 1) AS UNSIGNED)
//         AND CAST(SUBSTRING_INDEX(r.count, '-', -1) AS UNSIGNED) AND r.month = '${monthName}'
//     LEFT JOIN ${appSettings.rm_procure_db}.grn g 
//         ON ri.grn_id = g.grn_id 
//     LEFT JOIN (
//         SELECT indent_id, product 
//         FROM ${appSettings.rm_procure_db}.indent_items
//         GROUP BY indent_id, product
//     ) ii ON ii.indent_id = ri.indent_id
//     LEFT JOIN ${appSettings.masters_db}.products p 
//         ON p.product_id = ii.product
//     WHERE ii.product = 1;
// `;

      


//       let query = `${allquery} UNION ALL ${othersQuerry} UNION ALL ${blackTigerQuerry}`;
//       const results = await manager.query(query);
//       const enhancedResults = [];

//       for (const result of results) { 
//           const count = result.count;
//           console.log(isNaN(parseInt(count)),'resulttttttt');
          
//           let plusOneResults
//           if (count && !isNaN(parseInt(count))) { // Check if count is a number (not 'OTHERS', etc.)
//               const low = parseInt(count);
//               const high = parseInt(count);
//               const rangeResults = await manager.query(baseQuery(`CAST(ri.count AS UNSIGNED) BETWEEN ${low} AND ${high}`) + `GROUP BY r.count`);
//               if(rangeResults.length > 0)
//               {
//                   enhancedResults.push(...rangeResults);
//               }
              
//                plusOneResults = await manager.query(baseQuery(`CAST(ri.count AS UNSIGNED) BETWEEN ${low + 1} AND ${high + 1}`) + `GROUP BY r.count`);
//             }
// console.log(plusOneResults,'plusOneResults');
//           }
//       if (results.length > 0) {
//           return new Response(true, 1, 'Data retrieved successfully', results, dates); // Return the generated dates
//       } else {
//           return new Response(false, 0, 'No data found', [], []);
//       }

//   } catch (err) {
//       throw err;
//   }
// }

async getRmRates(req:any[]): Promise<CommonResponse> {
    try {
      const manager = getManager();
      interface priceInfoModel {
        count: string,
        lhPrice: number,
        rwPrice: number,
        colorVar: boolean
      }
     
      let result =[]
      const processedDates = new Set()
      console.log(req,'reqqqqqqqqqqq');
      
      for(const reqDate of req){
let  query = `  SELECT
        rl.count,DATE(rl.effective_from)  AS uploadedDate,DATE(rl.effective_to_date) AS effectedDate,
    MAX(CASE WHEN TYPE = 'Re Weighment' THEN rl.price ELSE 0 END) AS ReWeighmentPrice,
       MAX(CASE WHEN TYPE = 'Live Harvest' THEN rl.price ELSE 0 END) AS LiveHarvestPrice
      FROM
        ${appSettings.rm_procure_db}.rm_rates_logs rl
        LEFT JOIN ${appSettings.rm_procure_db}.rm_rates r ON r.rm_rates_id = rl.rm_rates_id
      WHERE
        category = 'Own'
        AND r.count BETWEEN 28 AND 100
        AND DATE('${reqDate}') BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date)
      GROUP BY rl.count
      ORDER BY rl.count,rl.effective_from DESC`;

      let         info = await manager.query(query);
      
// console.log(info,'infooooo');

      // If no data found in rm_rates, try rm_log
      if (!info || info.length === 0) {
        console.log(info.length);
        
        query = `
        SELECT
          count,DATE(updated_at) as uploadedDate,CURRENT_DATE as effectedDate,
          MAX(CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
          MAX(CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
      FROM
          ${appSettings.rm_procure_db}.rm_rates r
      WHERE
        category = 'Own'
        AND r.count BETWEEN 28 AND 100
         
  GROUP BY
          r.count;
      `;
       
        info = await manager.query(query);
      }

      // If still no data, find the closest previous date
      // if (!info || info.length === 0) {
      //   query = `
      //     SELECT
      //       count,DATE(updated_at) as uploadedDate,
      //       (CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
      //       (CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
      //     FROM
      //       ${appSettings.rm_procure_db}.rm_rates r
      //     WHERE
      //       category = 'Own'
      //       AND r.count BETWEEN 28 AND 100
      //       AND DATE(updated_at) =(SELECT MAX(DATE(updated_at)) FROM ${appSettings.rm_procure_db}.rm_rates WHERE DATE(updated_at) < '${reqDate}')
      //     GROUP BY
      //       r.count
      //     ORDER BY
      //       DATE(updated_at) DESC
          
      //   `;
      //   info = await manager.query(query, [reqDate]);
      //   if (!info || info.length === 0){
      //     query = `
      //     SELECT
      //       rl.count,DATE(rl.effective_from) as uploadedDate,
      //       (CASE WHEN r.type = 'Re Weighment' THEN r.price ELSE 0 END) AS ReWeighmentPrice,
      //       (CASE WHEN r.type = 'Live Harvest' THEN r.price ELSE 0 END) AS LiveHarvestPrice
      //     FROM
      //       ${appSettings.rm_procure_db}.rm_rates_logs rl
      //                   left join ${appSettings.rm_procure_db}.rm_rates r on r.rm_rates_id= rl.rm_rates_id

      //     WHERE
      //       category = 'Own'
      //       AND rl.count BETWEEN 28 AND 100
      //       AND DATE(rl.effective_from) =(SELECT MAX(DATE(effective_from)) FROM ${appSettings.rm_procure_db}.rm_rates_logs WHERE DATE(effective_from) <  '${reqDate}')
      //     GROUP BY
      //       rl.count
      //     ORDER BY
      //       DATE(rl.effective_from) DESC
          
      //   `;
      //     info = await manager.query(query, [reqDate]);
      //   }
      // }
      // console.log(info,'ooooooooooo');
      
      if(info.length>0 ){
        const uploadedDate = moment(info[0].uploadedDate).format('YYYY-MM-DD')
        const effectedDate = moment(info[0].effectedDate).format('YYYY-MM-DD')
        let combKey = JSON.stringify([uploadedDate,effectedDate]);

        if (!processedDates.has(combKey)) {
          // console.log(!processedDates.has(uploadedDate),'uploadedDateuploadedDate');
          let priceInfo: priceInfoModel[] = [];
          let prevCount
          let prevLhPrice = 0
          let prevRwPrice = 0
          let countVal
          let sameCounts: number[] = []
          let colorVal
        for (const priceRec of info) {
          const recordDate = moment(priceRec.uploadedDate).format('YYYY-MM-DD');
          const recordDate2 = moment(priceRec.effectedDate).format('YYYY-MM-DD');
          const keyComb = JSON.stringify([recordDate,recordDate2]);

      if (keyComb !== combKey) continue;
          if (prevLhPrice == priceRec.LiveHarvestPrice && prevRwPrice == priceRec.ReWeighmentPrice) {
            sameCounts.push(prevCount)
            countVal = Math.min(...sameCounts) + '-' + priceRec.count
            priceInfo.splice(-1)
            colorVal = true
          } else {
            sameCounts = []
            countVal = priceRec.count
            colorVal = false
          }
          priceInfo.push({ count: countVal, lhPrice: priceRec.LiveHarvestPrice, rwPrice: priceRec.ReWeighmentPrice, colorVar: colorVal })
          prevCount = priceRec.count
          prevLhPrice = priceRec.LiveHarvestPrice
          prevRwPrice = priceRec.ReWeighmentPrice

        }
        result.push({date:uploadedDate,effectedDate:effectedDate,rates:priceInfo})
        processedDates.add(combKey);
      }
      }
      }
//       let query = ` SELECT
//      count,
//     SUM(CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
//     SUM(CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
// FROM
//     ` + appSettings.rm_procure_db + `.rm_rates r
// WHERE
//     category = 'Own'
//     AND r.count BETWEEN 28 AND 100
//     AND DATE(updated_at) =(SELECT MAX(DATE(updated_at)) FROM ` + appSettings.rm_procure_db + `.rm_rates)
// GROUP BY
//     r.count;`

//       const info = await manager.query(query);

      
//       if (info) {
//         for (const priceRec of info) {
//           if (prevLhPrice == priceRec.LiveHarvestPrice && prevRwPrice == priceRec.ReWeighmentPrice) {
//             sameCounts.push(prevCount)
//             countVal = Math.min(...sameCounts) + '-' + priceRec.count
//             priceInfo.splice(-1)
//             colorVal = true
//           } else {
//             sameCounts = []
//             countVal = priceRec.count
//             colorVal = false
//           }
//           priceInfo.push({ count: countVal, lhPrice: priceRec.LiveHarvestPrice, rwPrice: priceRec.ReWeighmentPrice, colorVar: colorVal })
//           prevCount = priceRec.count
//           prevLhPrice = priceRec.LiveHarvestPrice
//           prevRwPrice = priceRec.ReWeighmentPrice

//         }

        return new CommonResponse(true, 1, 'Data retrieved', result)
      // } else {
      //   return new CommonResponse(false, 0, 'No data found')
      // }

    } catch (err) {
      throw err
    }

  }
//   async getRmRates(req:any[]): Promise<CommonResponse> {
//     try {
//       const manager = getManager();
//       interface priceInfoModel {
//         count: string,
//         lhPrice: number,
//         rwPrice: number,
//         colorVar: boolean,
//         productName: string
//       }
     
//       let result =[]
//       const processedDates = new Set()
//       console.log(req,'reqqqqqqqqqqq');
      
//       for(const reqDate of req){
// let  query = `  SELECT p.name as productName,
//         rl.count,DATE(rl.effective_from)  AS uploadedDate,DATE(rl.effective_to_date) AS effectedDate,
//     MAX(CASE WHEN TYPE = 'Re Weighment' THEN rl.price ELSE 0 END) AS ReWeighmentPrice,
//        MAX(CASE WHEN TYPE = 'Live Harvest' THEN rl.price ELSE 0 END) AS LiveHarvestPrice
//       FROM
//         ${appSettings.rm_procure_db}.rm_rates_logs rl
//         LEFT JOIN ${appSettings.rm_procure_db}.rm_rates r ON r.rm_rates_id = rl.rm_rates_id
//         LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=rl.product_id
//       WHERE
//         category = 'Own'
//         AND r.count BETWEEN 28 AND 100
//         AND DATE('${reqDate}') BETWEEN DATE(rl.effective_from) AND DATE(rl.effective_to_date)
//       GROUP BY rl.count,rl.product_id
//       ORDER BY rl.count,rl.effective_from DESC`;

//       let         info = await manager.query(query);
      
// // console.log(info,'infooooo');

//       // If no data found in rm_rates, try rm_log
//       if (!info || info.length === 0) {
//         console.log(info.length);
        
//         query = `
//         SELECT p.name as productName,
//           count,DATE(r.updated_at) as uploadedDate,CURRENT_DATE as effectedDate,
//           MAX(CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
//           MAX(CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
//       FROM
//           ${appSettings.rm_procure_db}.rm_rates r
//           LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=r.product_id
//       WHERE
//         category = 'Own'
//         AND r.count BETWEEN 28 AND 100
         
//   GROUP BY
//           r.count,r.product_id;
//       `;
       
//         info = await manager.query(query);
//       }

//       // If still no data, find the closest previous date
//       // if (!info || info.length === 0) {
//       //   query = `
//       //     SELECT
//       //       count,DATE(updated_at) as uploadedDate,
//       //       (CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
//       //       (CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
//       //     FROM
//       //       ${appSettings.rm_procure_db}.rm_rates r
//       //     WHERE
//       //       category = 'Own'
//       //       AND r.count BETWEEN 28 AND 100
//       //       AND DATE(updated_at) =(SELECT MAX(DATE(updated_at)) FROM ${appSettings.rm_procure_db}.rm_rates WHERE DATE(updated_at) < '${reqDate}')
//       //     GROUP BY
//       //       r.count
//       //     ORDER BY
//       //       DATE(updated_at) DESC
          
//       //   `;
//       //   info = await manager.query(query, [reqDate]);
//       //   if (!info || info.length === 0){
//       //     query = `
//       //     SELECT
//       //       rl.count,DATE(rl.effective_from) as uploadedDate,
//       //       (CASE WHEN r.type = 'Re Weighment' THEN r.price ELSE 0 END) AS ReWeighmentPrice,
//       //       (CASE WHEN r.type = 'Live Harvest' THEN r.price ELSE 0 END) AS LiveHarvestPrice
//       //     FROM
//       //       ${appSettings.rm_procure_db}.rm_rates_logs rl
//       //                   left join ${appSettings.rm_procure_db}.rm_rates r on r.rm_rates_id= rl.rm_rates_id

//       //     WHERE
//       //       category = 'Own'
//       //       AND rl.count BETWEEN 28 AND 100
//       //       AND DATE(rl.effective_from) =(SELECT MAX(DATE(effective_from)) FROM ${appSettings.rm_procure_db}.rm_rates_logs WHERE DATE(effective_from) <  '${reqDate}')
//       //     GROUP BY
//       //       rl.count
//       //     ORDER BY
//       //       DATE(rl.effective_from) DESC
          
//       //   `;
//       //     info = await manager.query(query, [reqDate]);
//       //   }
//       // }
//       // console.log(info,'ooooooooooo');
      
//       if(info.length>0 ){
// const productGroups = info.reduce((acc, row) => {
//   if (!acc[row.productName]) acc[row.productName] = [];
//   acc[row.productName].push(row);
//   return acc;
// }, {});
// for (const productName of Object.keys(productGroups)) {
  
//   const rows = productGroups[productName];
// rows.sort((a, b) => Number(a.count) - Number(b.count));
//   const uploadedDate = moment(rows[0].uploadedDate).format('YYYY-MM-DD');
//   const effectedDate = moment(rows[0].effectedDate).format('YYYY-MM-DD');
//   let combKey = JSON.stringify([productName, uploadedDate, effectedDate]);

//   if (processedDates.has(combKey)) continue;

//   let priceInfo: priceInfoModel[] = [];
//   let prevCount;
//   let prevLhPrice = 0;
//   let prevRwPrice = 0;
//   let sameCounts: number[] = [];
//   let colorVal;
//   let countVal;

//   for (const rec of rows) {

//     if (prevLhPrice === rec.LiveHarvestPrice && prevRwPrice === rec.ReWeighmentPrice) {
//       sameCounts.push(prevCount);
//       countVal = Math.min(...sameCounts) + '-' + rec.count;
//       priceInfo.splice(-1);
//       colorVal = true;
//     } else {
//       sameCounts = [];
//       countVal = rec.count;
//       colorVal = false;
//     }

//     priceInfo.push({
//       count: countVal,
//       lhPrice: rec.LiveHarvestPrice,
//       rwPrice: rec.ReWeighmentPrice,
//       colorVar: colorVal,
//       productName: rec.productName
//     });

//     prevCount = rec.count;
//     prevLhPrice = rec.LiveHarvestPrice;
//     prevRwPrice = rec.ReWeighmentPrice;
//   }

//   result.push({
//     date: uploadedDate,
//     effectedDate: effectedDate,
//     product: productName,
//     rates: priceInfo
//   });

//   processedDates.add(combKey);
// }

//       }
//       }
// //       let query = ` SELECT
// //      count,
// //     SUM(CASE WHEN TYPE = 'Re Weighment' THEN price ELSE 0 END) AS ReWeighmentPrice,
// //     SUM(CASE WHEN TYPE = 'Live Harvest' THEN price ELSE 0 END) AS LiveHarvestPrice
// // FROM
// //     ` + appSettings.rm_procure_db + `.rm_rates r
// // WHERE
// //     category = 'Own'
// //     AND r.count BETWEEN 28 AND 100
// //     AND DATE(updated_at) =(SELECT MAX(DATE(updated_at)) FROM ` + appSettings.rm_procure_db + `.rm_rates)
// // GROUP BY
// //     r.count;`

// //       const info = await manager.query(query);

      
// //       if (info) {
// //         for (const priceRec of info) {
// //           if (prevLhPrice == priceRec.LiveHarvestPrice && prevRwPrice == priceRec.ReWeighmentPrice) {
// //             sameCounts.push(prevCount)
// //             countVal = Math.min(...sameCounts) + '-' + priceRec.count
// //             priceInfo.splice(-1)
// //             colorVal = true
// //           } else {
// //             sameCounts = []
// //             countVal = priceRec.count
// //             colorVal = false
// //           }
// //           priceInfo.push({ count: countVal, lhPrice: priceRec.LiveHarvestPrice, rwPrice: priceRec.ReWeighmentPrice, colorVar: colorVal })
// //           prevCount = priceRec.count
// //           prevLhPrice = priceRec.LiveHarvestPrice
// //           prevRwPrice = priceRec.ReWeighmentPrice

// //         }

//         return new CommonResponse(true, 1, 'Data retrieved', result)
//       // } else {
//       //   return new CommonResponse(false, 0, 'No data found')
//       // }

//     } catch (err) {
//       throw err
//     }

//   }



  async getGrnData(): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT * FROM grn  `
      const details = await manager.query(query);
      if (details.length > 0) {
        return new CommonResponse(true, 1, 'Data Retrived', details)
      }
      else {
        return new CommonResponse(false, 1, 'No data found', details)
      }
    }
    catch (err) {
      throw err
    }
  }

  async getRawMaterialGrn(req: GrnIDRequest): Promise<CommonResponse> {
    try {
      const manager = getManager();
      let query = `SELECT gi.count,gi.quantity,g.voucher_number as voucherNumber,i.indent_code as indentCode,gi.plant_lot_number AS lotNum,g.grn_number AS grnNum,
      gi.soft_percentage AS softPercent,gi.reweighment_quantity AS reweighmentQty,v.vehicle_num as vehicleNum,
      g.reweighment_date AS reWeighmentDate,gi.indent_id as IndentId,
      re.quantity as Qty,sum(if(gi.reweighment_boxes>0,gi.reweighment_boxes,gi.boxes)) AS noOfCrates,s.name AS farmer,p.name AS product ,SUM(gi.price) as ratePerKg,i.harvest_type AS harvestType,gi.reweighment_count as rmCount,g.grn_date as grnDate,
      s.city,s.street,s.postal_code AS postalCode,g.reweighment_bill_to AS company,u.unit_code_id AS plantId,g.vehicle_number as vehicleNumber,ii.broker,f.city as dealerCity,f.street as dealerStreet,f.postal_code AS dealerPostalCode,f.name as dealer,i.supplier_type as supplierType,g.seal_number as seal,gi.main_batch_num AS mainBatchNo
      FROM `+ appSettings.rm_procure_db + `.grn_items gi
      LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing re ON re.grn_item_id = gi.grn_item_id
            LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id= gi.product
            LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
            LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = g.indent_no
            LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii ON ii.indent_id = i.indent_id
            LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = ii.broker
            LEFT JOIN `+ appSettings.transport_db + `.vehicle_assignment v ON v.indent_id = gi.indent_id
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.company = g.reweighment_bill_to AND  plant_type = '${UnitTypeEnum.MANUFACTURING_PLANT}'
            WHERE gi.main_batch_num= '${req.batchNumber}' and gi.year='${req.year}'`
      query = query+` GROUP BY gi.count,gi.grn_item_id `
      let deffectsQuerry =`SELECT gi.count,gi.quantity,gi.plant_lot_number AS lotNum,g.grn_number AS grnNum,
      gi.soft_percentage AS softPercent,gi.reweighment_quantity AS reweighmentQty,v.vehicle_num as vehicleNum,
      g.reweighment_date AS reWeighmentDate,gi.indent_id as IndentId,gid.quantity as defectQty,
      re.quantity as Qty,sum(if(gi.reweighment_boxes>0,gi.reweighment_boxes,gi.boxes)) AS noOfCrates,s.name AS farmer,p.name AS product ,SUM(gi.price) as ratePerKg,i.harvest_type AS harvestType,d.defect_name AS defect,gi.reweighment_count as rmCount,g.grn_date as grnDate,
      s.city,s.street,s.postal_code AS postalCode,g.reweighment_bill_to AS company,u.unit_code_id AS plantId,g.vehicle_number as vehicleNumber,ii.broker,f.city as dealerCity,f.street as dealerStreet,f.postal_code AS dealerPostalCode,f.name as dealer,i.supplier_type as supplierType,g.seal_number as seal,gid.grn_item__defects_id as grnDeffectId,gi.main_batch_num AS mainBatchNo
      FROM `+ appSettings.rm_procure_db + `.grn_items gi
      LEFT JOIN `+ appSettings.rm_procure_db + `.rm_re_weighing re ON re.grn_item_id = gi.grn_item_id
            LEFT JOIN `+ appSettings.masters_db + `.suppliers s ON s.supplier_id = gi.farmer
            LEFT JOIN `+ appSettings.masters_db + `.products p ON p.product_id= gi.product
            LEFT JOIN `+ appSettings.rm_procure_db + `.grn g ON g.grn_id = gi.grn_id
            LEFT JOIN `+ appSettings.rm_procure_db + `.indent i ON i.indent_id = g.indent_no
            LEFT JOIN `+ appSettings.rm_procure_db + `.indent_items ii ON ii.indent_id = i.indent_id
            LEFT JOIN `+ appSettings.masters_db + `.suppliers f ON f.supplier_id = ii.broker
            LEFT JOIN `+ appSettings.transport_db + `.vehicle_assignment v ON v.indent_id = gi.indent_id
            LEFT JOIN `+ appSettings.rm_procure_db + `.grn_item_defects gid ON gid.grn_item_id = gi.grn_item_id 
            LEFT JOIN `+ appSettings.masters_db + `.defect d ON d.defect_id = gid.defect_id 
            LEFT JOIN `+ appSettings.masters_db + `.unitcodes u ON u.company = g.reweighment_bill_to AND  plant_type = '${UnitTypeEnum.MANUFACTURING_PLANT}'
            WHERE gi.main_batch_num= '${req.batchNumber}'  and gi.year='${req.year}'
             GROUP BY gi.count,gi.grn_item_id,gid.defect_id`
      const details = await manager.query(query); 
      const deffectaDtails = await manager.query(deffectsQuerry);
      let response= []
      response.push({details:details,deffects:deffectaDtails})
      // let deffectsMap = new Map<number,any[]>()
      // let deffects=[]
      // let response= []
      // for(const val of deffectaDtails){
      //   if(!deffectsMap.has(val.grnDeffectId)){
      //     deffectsMap.set(val.grnDeffectId,[])
      //   }
      //   deffectsMap.get(val.grnDeffectId).push({ qty:val.defectQty,name: val.defect, count:val.rmCount});
      // }
      return new CommonResponse(true, 1, 'No data found', response)

    } catch (err) {
      throw err
    }

  }


  async updatePath(filePath: string, filename: string, grnId: number): Promise<FileUploadResponse> {
    console.log(filePath, 'ffffffffff')
    console.log(filename, 'nnnnnnnnnnnnnnnnnn')
    console.log(grnId, 'iddddddddddddddddd')
    try {
      const filePathUpdate = await this.grnRepository.update(
        { grnId: grnId },
        { filePath: filePath, fileName: filename },

      );
      if (filePathUpdate.affected > 0) {
        return new FileUploadResponse(true, 11, 'uploaded successfully', filePath);
      }
      else {
        return new FileUploadResponse(false, 11, 'uploaded failed', filePath);
      }
    }
    catch (error) {
      console.log(error);
    }
  }


  async getGrnPrint(req: GrnIDRequest): Promise<CommonResponse> {
    const manager = getManager()
    let query = `SELECT 
    grni.grn_item_id AS grnItemId,grni.grn_id ,grni.po_id ,grni.item_id,grni.received_quantity AS receivedQuantity,grni.unit_price AS unitPrice,
    grni.discount_per AS discountPer,grni.tax_per AS grnTaxPer, grni.created_at,
    grn.grn_id,DATE(grn.grn_date) AS grnDate, DATE(grn.invoice_date) AS genInvDate,grn.grn_no AS grnNumber, grn.inv_no AS grnInvNum,grn.vendor_id AS grnVendorId,grn.unit_id,
    DATE(purchase_order_date) AS poDate,po.vendor_name AS poVendorId,po.payment_terms AS paymentTerms,po.po_number AS poNumber,po.plant_address AS plantAddress,
    po.delivery_address AS deliveryAddress,po.delivery_terms AS deliveryTerms,
    ve.vendor_name AS grnVendorName,ve.gst_number AS grnGstNumber,ve.contact_person AS grnContactPerson,
    ve.street AS grnStreet,ve.apartment AS grnApartment,ve.city AS grnCity,
    ve.email_id AS grnEmailId,ve.country_id AS grnCountryId,ve.state_name AS grnstateName,
    vePo.vendor_name AS poVendorName,vePo.gst_number AS poGstNumber,vePo.street AS poStreet,vePo.city AS poCity,
    vePo.email_id AS poEmailId,vePo.country_id AS poCountry,vePo.state_name AS poStateName,
    co.country_name AS grnCountryName,coPo.country_name AS poCountryName,
    t.tax_name AS taxName,t.tax_percentage AS taxPercentage,t.tax_category AS taxCategory,
    i.item_name AS ProductDescription,s.size_name AS sizeName,pt.payment_terms_name,dt.delivery_terms_name,
     uc.unit_name AS unitName,uc.village_name,uc.mandal_name,uc.distirct_name,uc.postal_code,uc.fei_number,
    uc.fda_reg_number,uc.state_name,i.item_uom as itemUomId,uom.uom_name as itemUom

FROM  ` + appSettings.procure_db + `.grn_items grni
LEFT JOIN  ` + appSettings.procure_db + `.grn grn ON grn.grn_id = grni.grn_id
LEFT JOIN  ` + appSettings.procure_db + `.purchase_order po ON po.purchase_order_id = grni.po_id
LEFT JOIN ` + appSettings.masters_db + `.vendors ve ON ve.vendor_id=grn.vendor_id
LEFT JOIN ` + appSettings.masters_db + `.vendors vePo ON vePo.vendor_id=po.vendor_name
LEFT JOIN ` + appSettings.masters_db + `.countries co ON co.country_id=ve.country_id
LEFT JOIN ` + appSettings.masters_db + `.countries coPo ON coPo.country_id=vePo.country_id
LEFT JOIN ` + appSettings.masters_db + `.taxes t ON t.tax_id=grni.tax_per
LEFT JOIN ` + appSettings.masters_db + `.items i ON i.item_id=grni.item_id
LEFT JOIN ` + appSettings.masters_db + `.sizes s ON s.size_id=grni.size_id
LEFT JOIN ` + appSettings.masters_db + `.payment_terms pt ON pt.payment_terms_id=po.payment_terms
LEFT JOIN ` + appSettings.masters_db + `.delivery_terms dt ON dt.delivery_terms_id=po.delivery_terms
LEFT JOIN ` + appSettings.masters_db + `.unitcodes uc ON uc.unit_code_id=grn.unit_id
LEFT JOIN ` + appSettings.masters_db + `.uoms uom ON uom.uom_id=i.item_uom
WHERE grni.grn_id= ${req.grnId}
 `;
    console.log(query)
    const data = await manager.query(query);
    console.log(data,'dataaaa');
    
    if (data) {
      return new CommonResponse(true, 1121, 'Data retrieved successfully', data)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  }


  async getInspectionDetails(): Promise<CommonResponse> {
    try {
      const manager = getManager()
      const inspections = `select g.grn_id,g.grn_no,g.inv_no as invNo,gi.received_quantity as grnQuantity,g.vendor_id,gi.inspected_qty as inspectionQuantity,gi.grn_item_id as grnItemId,ve.vendor_name as vendor,gi.item_id,
    i.item_name as itemName,gi.inspection_status
    from ${appSettings.procure_db}.grn_items gi
    left join ${appSettings.procure_db}.grn g on g.grn_id=gi.grn_id
    left join ${appSettings.masters_db}.vendors ve on ve.vendor_id=g.vendor_id
    left join ${appSettings.masters_db}.items i on i.item_id=gi.item_id
    where gi.inspection_status="1"`
      const insdetails = await manager.query(inspections)
      console.log(insdetails, "0000000000000")

      if (insdetails.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved successfully', insdetails)

      } else {
        return new CommonResponse(false, 0, 'No data')

      }

    } catch (err) {
      throw (err)
    }

  }



  async getStatusDetails(req: GrnItemIdRequest): Promise<CommonResponse> {

    try {
      const manager = getManager()
      const status = `select gri.status as status, gri.quantity, gri.reason_id, r.reasons_name as reason,r.reasons_id,gri.created_at  as inspectionDate,grni.grn_item_id as grnItemId
      from ${appSettings.procure_db}.grn_inspection gri
      left join ${appSettings.masters_db}.reasons r on r.reasons_id = gri.reason_id
      left join ${appSettings.procure_db}.grn_items grni on grni.grn_item_id=gri.grn_item_id
      WHERE grni.grn_item_id = '${req.grnItemId}'`
      const statusDetails = await manager.query(status)
      console.log(statusDetails, "----------------")

      if (statusDetails.length > 0) {
        return new CommonResponse(true, 1121, 'Data retrieved successfully', statusDetails)
      } else {
        return new CommonResponse(false, 1121, 'No data')
      }
    } catch (err) {
      throw (err)
    }



  }

//   async getRmRecievingReportOthersSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
//   try {
//       const manager = getManager();
//       const grnDate = moment(req.grnDate); 
//       const targetMonth = grnDate.month();
//       const targetYear = grnDate.year();
//       const startingDate = moment({ year: targetYear, month: targetMonth, day: 1 })
//       const formattedStartDate = startingDate.format('YYYY-MM-DD');
//       const formattedEndDate = grnDate.format('YYYY-MM-DD');
//           let startDate = grnDate.clone().subtract(10, 'days'); 
//  const nextDates = [];
//       let dates = []
//       let currentDate = startDate.clone();
//       let datesToAdd = 0; 
    

//       if(startDate.month() === targetMonth){
//         datesToAdd = 10;
//     }else{
//       const startOfMonth = moment({ year: targetYear, month: targetMonth, day: 1 });
//   datesToAdd = grnDate.diff(startOfMonth, 'days') + 1; 
//         }
//         for (let i = 0; i < datesToAdd; i++) {
//           if (currentDate.month() !== targetMonth) {
//             if(startingDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')){
  
//               nextDates.push(startingDate.format('YYYY-MM-DD'));
//               dates.push({ date: startingDate.format('YYYY-MM-DD') });
//             }
//               // Case: When the current month is different from the target month
//               startingDate.add(1, 'day');
//           } else {
//               // Case: When the current month matches the target month
//               if (startDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
//                   nextDates.push(startDate.format('YYYY-MM-DD'));
//                   dates.push({ date: startDate.format('YYYY-MM-DD') });
//               }
//               startDate.add(1, 'day');
//           }
//       }
//     // dates =nextDates.filter(date => date !== formattedEndDate)

//       // console.log(nextDates,'ooooooooo');
//       // nextDates = nextDates.filter(date => date !== formattedEndDate)
//       let opBalEndDate;
//       if (datesToAdd > 0) {
//           opBalEndDate = grnDate.clone().subtract(datesToAdd + 1, 'days');
//           if (opBalEndDate.month() !== targetMonth) {
//               opBalEndDate = null; // Set to null if not in the same month, which will result in 0 in query
//           }
//       } else {
//           opBalEndDate = null;
//       }
      
//       let opBalFormattedEndDate = opBalEndDate ? opBalEndDate.format('YYYY-MM-DD') : null;
//       const monthNames = [
//           "January", "February", "March", "April", "May", "June",
//           "July", "August", "September", "October", "November", "December"
//       ];
//       const monthName = monthNames[targetMonth];

    
//       let dateSumCases = nextDates.filter(date => date !== formattedEndDate)
//           .map((date, index) => `SUM(CASE WHEN DATE(gi.reweighment_date)='${date}' THEN ri.quantity ELSE 0 END) AS day${index + 1}`)
//     .join(', '); // Join clauses with a comma and space
//     // console.log("Start Date:", formattedStartDate);
//     // console.log("End Date:", formattedEndDate);
//     // console.log("opBal End Date:", opBalFormattedEndDate);
//     // console.log("Date Sum Cases:", dateSumCases);
    
//     const opBalCondition =
//     dates[0]?.date === formattedStartDate
//     ? '0'
//     : `SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND ${opBalFormattedEndDate ? `'${opBalFormattedEndDate}'` : 'NULL'} THEN ri.quantity ELSE 0 END)`;
    
//     const othersQuerry = `SELECT ri.count AS count, NULL AS rmQty,
//     ${opBalCondition} AS opBal
//     ${dateSumCases ? `, ${dateSumCases}` : ''},
//     SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
//     SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
//     FROM ${appSettings.rm_procure_db}.rm_invoice ri
//     LEFT JOIN ${appSettings.rm_procure_db}.grn g ON ri.grn_id = g.grn_id
//     WHERE NOT EXISTS (
//       SELECT 1
//       FROM ${appSettings.masters_db}.rm_budget rb
//       WHERE rb.year = '${targetYear}'
//       AND rb.month = '${monthName}'
//       AND CAST(ri.count AS UNSIGNED) BETWEEN CAST(SUBSTRING_INDEX(rb.count, '-', AS UNSIGNED)
//       AND CAST(SUBSTRING_INDEX(rb.count, '-', -1)+1 AS UNSIGNED)
//       )
//       AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
//       GROUP BY ri.count`;
      
      
//       // console.log("Final Query:", othersQuerry);
      


//       const results = await manager.query(othersQuerry);

//       if (results.length > 0) {
//           return new Response(true, 1, 'Data retrieved successfully', results, dates); // Return the generated dates
//       } else {
//           return new Response(false, 0, 'No data found', [], []);
//       }

//   } catch (err) {
//       throw err;
//   }
// }
async getRmRecievingReportOthersSummary(req: RmReceivingReportReq): Promise<CommonResponse> {
  try {
      const manager = getManager();
      const grnDate = moment(req.grnDate); 
      const targetMonth = grnDate.month();
      const targetYear = grnDate.year();
      const startingDate = moment({ year: targetYear, month: targetMonth, day: 1 })
      const formattedStartDate = startingDate.format('YYYY-MM-DD');
      const formattedEndDate = grnDate.format('YYYY-MM-DD');
          let startDate = grnDate.clone().subtract(10, 'days'); 
 const nextDates = [];
      let dates = []
      let currentDate = startDate.clone();
      let datesToAdd = 0; 
    

      if(startDate.month() === targetMonth){
        datesToAdd = 10;
    }else{
      const startOfMonth = moment({ year: targetYear, month: targetMonth, day: 1 });
  datesToAdd = grnDate.diff(startOfMonth, 'days') + 1; 
        }
        for (let i = 0; i < datesToAdd; i++) {
          if (currentDate.month() !== targetMonth) {
            if(startingDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')){
  
              nextDates.push(startingDate.format('YYYY-MM-DD'));
              dates.push({ date: startingDate.format('YYYY-MM-DD') });
            }
              // Case: When the current month is different from the target month
              startingDate.add(1, 'day');
          } else {
              // Case: When the current month matches the target month
              if (startDate.format('YYYY-MM-DD') !== grnDate.format('YYYY-MM-DD')) {
                  nextDates.push(startDate.format('YYYY-MM-DD'));
                  dates.push({ date: startDate.format('YYYY-MM-DD') });
              }
              startDate.add(1, 'day');
          }
      }
    // dates =nextDates.filter(date => date !== formattedEndDate)

      // console.log(nextDates,'ooooooooo');
      // nextDates = nextDates.filter(date => date !== formattedEndDate)
      let opBalEndDate;
      if (datesToAdd > 0) {
          opBalEndDate = grnDate.clone().subtract(datesToAdd + 1, 'days');
          if (opBalEndDate.month() !== targetMonth) {
              opBalEndDate = null; // Set to null if not in the same month, which will result in 0 in query
          }
      } else {
          opBalEndDate = null;
      }
      
      let opBalFormattedEndDate = opBalEndDate ? opBalEndDate.format('YYYY-MM-DD') : null;
      const monthNames = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
      ];
      const monthName = monthNames[targetMonth];

    
      let dateSumCases = nextDates.filter(date => date !== formattedEndDate)
          .map((date, index) => `SUM(CASE WHEN DATE(gi.reweighment_date)='${date}' THEN ri.quantity ELSE 0 END) AS day${index + 1}`)
    .join(', '); // Join clauses with a comma and space
    // console.log("Start Date:", formattedStartDate);
    // console.log("End Date:", formattedEndDate);
    // console.log("opBal End Date:", opBalFormattedEndDate);
    // console.log("Date Sum Cases:", dateSumCases);
    
    const opBalCondition =
    dates[0]?.date === formattedStartDate
    ? '0'
    : `SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND ${opBalFormattedEndDate ? `'${opBalFormattedEndDate}'` : 'NULL'} THEN ri.quantity ELSE 0 END)`;
    
    // const othersQuerry = `SELECT ri.count AS count, NULL AS rmQty,
    // ${opBalCondition} AS opBal
    // ${dateSumCases ? `, ${dateSumCases}` : ''},
    // SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
    // SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
    // FROM ${appSettings.rm_procure_db}.rm_invoice ri
    // LEFT JOIN ${appSettings.rm_procure_db}.grn g ON ri.grn_id = g.grn_id
    // left join ${appSettings.rm_procure_db}.grn_items gi on gi.grn_item_id = ri.grn_item_id
    // WHERE NOT EXISTS (
    //   SELECT 1
    //   FROM ${appSettings.masters_db}.rm_budget rb
    //   WHERE rb.year = '${targetYear}'
    //   AND rb.month = '${monthName}'
    //   AND CAST(ri.count AS UNSIGNED) BETWEEN CAST(SUBSTRING_INDEX(rb.count, '-', 1) AS UNSIGNED)
    //   AND CAST(SUBSTRING_INDEX(rb.count, '-', -1) AS UNSIGNED)
    //   )
    //   AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
    //   GROUP BY ri.count`;
      
      
      // console.log("Final Query:", othersQuerry);
      

      const othersQuerry = `SELECT ri.count AS count, NULL AS rmQty,
      ${opBalCondition} AS opBal
      ${dateSumCases ? `, ${dateSumCases}` : ''},
      SUM(CASE WHEN DATE(gi.reweighment_date)='${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS selectedDate,
      SUM(CASE WHEN DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}' THEN ri.quantity ELSE 0 END) AS total
      FROM ${appSettings.rm_procure_db}.rm_invoice ri
      LEFT JOIN ${appSettings.rm_procure_db}.grn g ON ri.grn_id = g.grn_id
      left join ${appSettings.rm_procure_db}.grn_items gi on gi.grn_item_id = ri.grn_item_id
      where  gi.budget_range = 'Others'
        AND DATE(gi.reweighment_date) BETWEEN '${formattedStartDate}' AND '${formattedEndDate}'
        GROUP BY ri.count`;
        
      const results = await manager.query(othersQuerry);

      if (results.length > 0) {
          return new Response(true, 1, 'Data retrieved successfully', results, dates); // Return the generated dates
      } else {
          return new Response(false, 0, 'No data found', [], []);
      }

  } catch (err) {
      throw err;
  }
}

// async getRmRateReportData(req?:RmRatesReportReq): Promise<CommonResponse> {

//   try {
//     const manager = getManager()
//     let currentRatesQuery = `SELECT rr.rm_rates_id,rr.count,rr.price,rr.company,rr.category,rr.type,rr.updated_at AS effected,'CURRENT' AS status,cr.count_range_id as rangeId,p.name as product,p.product_id,
// CONCAT(cr.min_value,'-',cr.max_value) AS countRange FROM ${appSettings.rm_procure_db}.rm_rates  rr
// LEFT JOIN ${appSettings.rm_procure_db}.count_ranges cr ON cr.count_range_id = rr.count_range_id
// LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=rr.product_id
// `
//  let previousRatesQuery = `SELECT rr.rm_rates_id,rr.count,rr.price,rm.company,rm.category,rm.type,rr.effective_from AS effected,'PREVIOUS' AS status,cr.count_range_id as rangeId,p.name as product,p.product_id,
// CONCAT(cr.min_value,'-',cr.max_value) AS countRange FROM ${appSettings.rm_procure_db}.rm_rates_logs rr
// LEFT JOIN ${appSettings.rm_procure_db}.rm_rates rm ON rm.rm_rates_id = rr.rm_rates_id
// LEFT JOIN ${appSettings.rm_procure_db}.count_ranges cr ON cr.count_range_id = rm.count_range_id
// LEFT JOIN ${appSettings.masters_db}.products p ON p.product_id=rr.product_id
// `
// if (req?.rateDate) {
//   currentRatesQuery += ` WHERE DATE(rr.updated_at) <= '${req.rateDate}'`;
//   previousRatesQuery += ` WHERE DATE(rr.effective_from) <= '${req.rateDate}' AND DATE(rr.updated_at) >= '${req.rateDate}'`;
// }
// let query = `${currentRatesQuery} UNION ALL ${previousRatesQuery}`;
//   // Array to store conditions
//   let conditions: string[] = [];

//   // Apply filters dynamically
//   if (req.countRangeId !== undefined) {
//     conditions.push(`count = '${req.countRangeId}'`);
//   }
//    if (req.productId !== undefined) {
//   conditions.push(`product_id = '${req.productId}'`);
// }

//   if (req.status !== undefined) {
//     conditions.push(`status = '${req.status}'`);
//   }
//   if (req.fromDate !== undefined) {
//     conditions.push(`effected Between '${req.fromDate}' AND '${req.toDate}'`);
//   }

//   // Append conditions if any exist
//   if (conditions.length > 0) {
//     query = `SELECT * FROM (${query}) AS subquery WHERE ` + conditions.join(' AND ');
//   }
// // if(req.countRangeId!= undefined){
// //   console.log(req.countRangeId,'req.countRange');
  
// // }
// // if(req.status != undefined){
// //     console.log(req.status,'req.status');

// // }
//     const response = await manager.query(query)
//     // console.log(response, "----------------")

//     if (response.length > 0) {
//       return new CommonResponse(true, 1121, 'Data retrieved successfully', response)
//     } else {
//       return new CommonResponse(false, 1121, 'No data')
//     }
//   } catch (err) {
//     throw (err)
//   }
// }

async getRmRateReportData(req?:RmRatesReportReq): Promise<CommonResponse> {

  try {
    const manager = getManager()
    let currentRatesQuery = `SELECT rr.rm_rates_id,rr.count,rr.price,rr.company,rr.category,rr.type,rr.updated_at AS effected,'CURRENT' AS status,cr.count_range_id as rangeId,
CONCAT(cr.min_value,'-',cr.max_value) AS countRange FROM ${appSettings.rm_procure_db}.rm_rates  rr
LEFT JOIN ${appSettings.rm_procure_db}.count_ranges cr ON cr.count_range_id = rr.count_range_id`
 let previousRatesQuery = `SELECT rr.rm_rates_id,rr.count,rr.price,rm.company,rm.category,rm.type,rr.effective_from AS effected,'PREVIOUS' AS status,cr.count_range_id as rangeId,
CONCAT(cr.min_value,'-',cr.max_value) AS countRange FROM ${appSettings.rm_procure_db}.rm_rates_logs rr
LEFT JOIN ${appSettings.rm_procure_db}.rm_rates rm ON rm.rm_rates_id = rr.rm_rates_id
LEFT JOIN ${appSettings.rm_procure_db}.count_ranges cr ON cr.count_range_id = rm.count_range_id
`
if (req?.rateDate) {
  currentRatesQuery += ` WHERE DATE(rr.updated_at) <= '${req.rateDate}'`;
  previousRatesQuery += ` WHERE DATE(rr.effective_from) <= '${req.rateDate}' AND DATE(rr.updated_at) >= '${req.rateDate}'`;
}
let query = `${currentRatesQuery} UNION ALL ${previousRatesQuery}`;
  // Array to store conditions
  let conditions: string[] = [];

  // Apply filters dynamically
  if (req.countRangeId !== undefined) {
    conditions.push(`count = '${req.countRangeId}'`);
  }

  if (req.status !== undefined) {
    conditions.push(`status = '${req.status}'`);
  }
  if (req.fromDate !== undefined) {
    conditions.push(`effected Between '${req.fromDate}' AND '${req.toDate}'`);
  }

  // Append conditions if any exist
  if (conditions.length > 0) {
    query = `SELECT * FROM (${query}) AS subquery WHERE ` + conditions.join(' AND ');
  }
// if(req.countRangeId!= undefined){
//   console.log(req.countRangeId,'req.countRange');
  
// }
// if(req.status != undefined){
//     console.log(req.status,'req.status');

// }
    const response = await manager.query(query)
    // console.log(response, "----------------")

    if (response.length > 0) {
      return new CommonResponse(true, 1121, 'Data retrieved successfully', response)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  } catch (err) {
    throw (err)
  }
}
async getRmRateReportCountRanges(): Promise<CommonResponse> {

  try {
    const manager = getManager()
    const status = `SELECT distinct(rr.count) FROM ${appSettings.rm_procure_db}.rm_rates  rr
UNION ALL
SELECT distinct(rr.count) FROM ${appSettings.rm_procure_db}.rm_rates_logs rr
`
    const response = await manager.query(status)
    // console.log(response, "----------------")

    if (response.length > 0) {
      return new CommonResponse(true, 1121, 'Data retrieved successfully', response)
    } else {
      return new CommonResponse(false, 1121, 'No data')
    }
  } catch (err) {
    throw (err)
  }
}
async getMonthWisePurchaseAnalysisReport(req: getMonthWisePurchaseRequest): Promise<CommonResponse> {
  try {
    const manager = getManager();

    let query = `
      SELECT 
        rm.lot_number AS batchNo, 
        SUM(hon_count * hon_quantity) AS honProduct, 
        rm.farmer, 
       (CASE WHEN (rm.ice_rate >0 OR rm.commission>0) THEN inv_amount-(rm.ice_rate*grn_hon_quantity)-(rm.commission*grn_hon_quantity) ELSE inv_amount END ) AS purchaseValue, 
       inv_amount AS purchaseValueBefore,
        SUM((rm.rm_rate-(grn_rm_rate-ri.unit_price)) * hon_quantity) AS expectedValue, 
        rm.grn_date AS grnDate, 
        SUM(hon_quantity) AS totHonQnty, 
        SUM(grn_hon_quantity) AS totGrnHonQnty, 
        SUM((case when rm.harvest_type='Re Weighment' then rm.reweighment_count else grn_count end) * grn_hon_quantity) AS grnHonProduct,
        p.name as product, 
        SUM(rm.quantity) AS hlQty, 
        rm.rm_rate AS price, 
        rm.harvest_type  as harvestType,
        rm.year as year,
        hl.hl_percentage as hlPercentage,
        ((SUM(rm.quantity)/SUM(hon_quantity))*100) AS yeild,
       (((SUM(rm.quantity)/SUM(hon_quantity))*100)-COALESCE(hl.hl_percentage,0)) AS varience,
       DATE_FORMAT(ri.invoice_date, '%Y-%m-%d')  as invoiceDate,rm.intake_supervisor AS supervisor
      FROM ${appSettings.analytics_db}.rm_purchase_analysis rm
      LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.plant_lot_number = rm.lot_number AND rm.year = gi.year
      left join ${appSettings.rm_procure_db}.rm_invoice ri  ON ri.grn_item_id = gi.grn_item_id and ri.type = '${ShrimpTypeEnum.GOOD}'
      left join ${appSettings.rm_procure_db}.grn g on g.grn_id = gi.grn_id 
      left join  ${appSettings.masters_db}.products p on p.product_id = gi.product
LEFT JOIN (
    SELECT 
        gi.grn_item_id,
        MAX(hl.hl_percentage) AS hl_percentage  -- or MIN()
    FROM ${appSettings.rm_procure_db}.grn_items gi
    JOIN ${appSettings.masters_db}.hlpercentage hl 
        ON ROUND(COALESCE (gi.reweighment_count,gi.count),0) BETWEEN hl.min_grade AND hl.max_grade
        WHERE hl.type='RM'  
    GROUP BY gi.grn_item_id
) hl ON hl.grn_item_id = gi.grn_item_id
      WHERE 1=1

    `

    if (req) {
      query += ` AND DATE(rm.grn_date) between '${req.fromDate}' AND '${req.toDate}' `;
    }
   if (req.unit && req.unit != 5) {
      query += ' and g.plant_id = ' + req.unit;
        }
    query += ` GROUP BY rm.lot_number, rm.year`; // Removed 'rma.' since no alias is used

    const data = await manager.query(query); // Await the query execution

    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } catch (err) {
    throw err;
  }
}
async getDeffectsPurchaseAnalysis(req: BatchNumRequest): Promise<CommonResponse> {
  try {
    const manager = getManager();
    // const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
    // const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A',
    const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
    const batchData = batchNumArray.map(batch => {
      const parts = batch.split('-'); // Split by '-'
      const year = parts.pop(); // Extract the last part as year
      const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
      return { batchCode, year };
    });

    const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
    const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');

    let query = `
      SELECT ri.count,ri.quantity,(ri.unit_price-gi.ice_rate-i.commission) AS rate , ri.total_amount AS amount,ri.defect_id,d.defect_name as defect,ri.type,batch_number as batch,ri.unit_price as unitPrice FROM ${appSettings.rm_procure_db}.rm_invoice ri
      left join  ${appSettings.rm_procure_db}.grn_item_defects gid on gid.grn_item__defects_id = ri.defect_id
 LEFT JOIN ${appSettings.masters_db}.defect d ON d.defect_id = gid.defect_id
 LEFT JOIN ${appSettings.rm_procure_db}.grn_items gi ON gi.grn_item_id = ri.grn_item_id
 LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id

 WHERE batch_number IN (${formattedBatchCodes}) and gi.year IN(${formattedYears})
  GROUP BY ri.count, ri.defect_id  `
    const data = await manager.query(query); // Await the query execution

    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } catch (err) {
    throw err;
  }
}
async getDeffectsLivePurchaseAnalysis(req: BatchNumRequest): Promise<CommonResponse> {
  try {
    const manager = getManager();
    // const batchNumArray = req.batchNum.split(','); // ['R-0320', 'R-0320-A', 'R-0320-B']
    // const formattedBatchNum = batchNumArray.map(batch => `'${batch}'`).join(','); // "'R-0320','R-0320-A',
    const batchNumArray = req.batchNum.split(','); // ['R-1005-2024', 'R-1005-2025']
    
    const batchData = batchNumArray.map(batch => {
      const parts = batch.split('-'); // Split by '-'
      const year = parts.pop(); // Extract the last part as year
      const batchCode = parts.join('-'); // Rejoin the remaining parts as batch code
      return { batchCode, year };
    });

    const formattedBatchCodes = [...new Set(batchData.map(b => `'${b.batchCode}'`))].join(',');
    const formattedYears = [...new Set(batchData.map(b => `'${b.year}'`))].join(',');

    let query = `
      SELECT gi.reweighment_count AS reWeigCount,gi.count,gi.reweighment_quantity as reWequantity,(ri.unit_price-gi.ice_rate-i.commission) AS rate , ri.total_amount AS amount,ri.defect_id,d.defect_name as defect,ri.type,gi.quantity,batch_number as batch,ri.unit_price as unitPrice FROM ${appSettings.rm_procure_db}.rm_invoice ri
      left join  ${appSettings.rm_procure_db}.grn_item_defects gid on gid.grn_item__defects_id = ri.defect_id
 LEFT JOIN ${appSettings.masters_db}.defect d ON d.defect_id = gid.defect_id
 left join ${appSettings.rm_procure_db}.grn_items gi on gi.grn_item_id = ri.grn_item_id
  LEFT JOIN ${appSettings.rm_procure_db}.indent i ON i.indent_id = ri.indent_id
 WHERE batch_number IN (${formattedBatchCodes}) and gi.year IN(${formattedYears})
  GROUP BY ri.count, ri.defect_id 
    `
    const data = await manager.query(query); // Await the query execution

    return new CommonResponse(true, 1, 'Data retrieved successfully', data);
  } catch (err) {
    throw err;
  }
}

  async getTotalPackingPayablesDashboard(req?:PayablesDashboardReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry = `SELECT g.grn_id,invoice_date AS invoiceDate,SUM(gi.received_quantity) AS totalQuantity,SUM(gi.tot_amount),
SUM(gi.taxable_amount*0.001),
(SUM(gi.tot_amount)-SUM(gi.taxable_amount*0.001)) AS totalAMount,uc.company_id,uc.company FROM grn g
LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
 LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id`
      if(req.fromDate!=null && req.toDate!=null){
        getQry+=` WHERE invoice_date BETWEEN '${req.fromDate}' AND '${req.toDate}'`
      }
      if(req.unitId!=null){
        getQry+=` AND g.unit_id = '${req.unitId}'`
      }
      if(req.vendorId!=null){
        getQry+=` AND g.vendor_id = '${req.vendorId}'`
      }
      if(req.company!=null){
        getQry+=` AND uc.company_id = '${req.company}'`
      }
      const info = await manager.query(getQry)

      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

    async getTotalPackingVendorPayables(req?: PayablesDashboardReq): Promise<CommonResponse> {
    const manager = getManager()
    try {
      let query = `SELECT SUM(tot_amount) AS totalAmount,SUM(g.payment) AS totalPayment,((SUM(tot_amount)-SUM(gi.taxable_amount*0.001))-SUM(g.payment)) AS overdue,SUM(gi.taxable_amount*0.001) AS taxableAmount,uc.company_id,uc.company FROM grn_items gi
                         LEFT JOIN grn g ON gi.grn_id = g.grn_id
                          LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id
                          WHERE item_category_id = 6
                         `
      let whereClause = ``;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    query += whereClause ;
let paymentQuery = `
      SELECT SUM(g.payment) AS totalPayment
      FROM grn g
            LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = g.unit_id
 WHERE g.grn_id IN (
      SELECT grn_id FROM grn_items gi WHERE gi.item_category_id=6
      )
      ${whereClause}
    `;

    // Execute both queries
    const info = await manager.query(query);
    const paymentRes = await manager.query(paymentQuery);
    const payment = Number(paymentRes?.[0]?.totalPayment ?? 0);

    // Inject payment and overdue into each result row
    const data = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      return {
        ...row,
        totalPayment: payment,
        overdue: totalAmount - payment
      };
    });    
      if (data.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', data)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
            throw err
    }
  }
async getTotalPackingPaidsDashboard(req?: PayablesDashboardReq): Promise<CommonResponse> {
  const manager = getManager();
  try {
    // Build base query without payment and overdue
    let getQry = `
      SELECT 
        g.grn_id,
        invoice_date AS invoiceDate,
        (SUM(tot_amount) - SUM(gi.taxable_amount * 0.001)) AS totalAmount,
        uc.company_id,
        uc.company
      FROM grn g
      LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
    `;

    // Add filters
    let whereClause = ` WHERE 1=1 `;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    getQry += whereClause ;

    // Payment query
    let paymentQuery = `
      SELECT SUM(g.payment) AS totalPayment
      FROM grn g
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
      ${whereClause}
    `;

    // Execute both queries
    const info = await manager.query(getQry);
    const paymentRes = await manager.query(paymentQuery);
    const payment = Number(paymentRes?.[0]?.totalPayment ?? 0);

    // Inject payment and overdue into each result row
    const result = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      return {
        ...row,
        payment: payment,
        overdue: totalAmount - payment
      };
    });

    if (result.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved', result);
    } else {
      return new CommonResponse(false, 0, 'No data found');
    }
  } catch (err) {
    throw err;
  }
}

async getTotalGeneralVendorPayables(req?: PayablesDashboardReq): Promise<CommonResponse> {
    const manager = getManager()
    try {
      let query = `SELECT SUM(tot_amount) AS totalAmount,SUM(g.payment) AS totalPayment,((SUM(tot_amount)-SUM(gi.taxable_amount*0.001))-SUM(g.payment)) AS overdue,SUM(gi.taxable_amount*0.001) AS taxableAmount,uc.company_id,uc.company FROM grn_items gi
                         LEFT JOIN grn g ON gi.grn_id = g.grn_id
                          LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id
                          WHERE item_category_id = 33
                         `
      let whereClause = ``;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    query += whereClause ;
let paymentQuery = `
      SELECT SUM(g.payment) AS totalPayment
      FROM grn g
            LEFT JOIN erpx_dev_masters.unitcodes uc ON uc.unit_code_id = g.unit_id
 WHERE g.grn_id IN (
      SELECT grn_id FROM grn_items gi WHERE gi.item_category_id=33
      )
      ${whereClause}
    `;

    // Execute both queries
    const info = await manager.query(query);
    const paymentRes = await manager.query(paymentQuery);
    const payment = Number(paymentRes?.[0]?.totalPayment ?? 0);

    // Inject payment and overdue into each result row
    const data = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      return {
        ...row,
        totalPayment: payment,
        overdue: totalAmount - payment
      };
    });    
      if (data.length > 0) {
        return new CommonResponse(true, 1, 'Data retrieved', data)
      } else {
        return new CommonResponse(false, 0, 'No data found')
      }
    } catch (err) {
            throw err
    }
  }


  // async getTotalGeneralVendorPayables(req?: PayablesDashboardReq): Promise<CommonResponse> {
  //   const manager = getManager()
  //   try {
  //     let query = `SELECT SUM(tot_amount) AS totalAmount,SUM(g.payment) AS totalPayment,((SUM(tot_amount)-SUM(gi.taxable_amount*0.001))-SUM(g.payment)) AS overdue,SUM(gi.taxable_amount*0.001) AS taxableAmount,uc.company_id,uc.company  FROM grn_items gi
  //                        LEFT JOIN grn g ON gi.grn_id = g.grn_id
  //                        LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id

  //                        WHERE item_category_id = 33`

  //     if (req.fromDate != null && req.toDate != null) {
  //       query += ` AND DATE(g.invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`
  //     }
  //     if(req.unitId!=null){
  //       query+=` AND g.unit_id = '${req.unitId}'`
  //     }
  //     if(req.vendorId!=null){
  //       query+=` AND g.vendor_id = '${req.vendorId}'`
  //     }
  //     if(req.company!=null){
  //       query+=` AND uc.company_id = '${req.company}'`
  //     }
  //     const data = await manager.query(query)

  //     if (data.length > 0) {
  //       return new CommonResponse(true, 1, 'Data retrieved', data)
  //     } else {
  //       return new CommonResponse(false, 0, 'No data found')
  //     }
  //   } catch (err) {
  //     throw err
  //   }
  // }

async getPayablesViewData(req?: any): Promise<CommonResponse> {
  const manager = getManager();
  try {
    let query = `
      SELECT 
        SUM(tot_amount) AS totalPayables,
        g.invoice_date AS invoiceDate,
        g.inv_no AS invoiceNo,
        v.vendor_name AS vendorName,
        v.vendor_code AS vendorCode,
        SUM(gi.taxable_amount * 0.001) AS taxableAmount,
        DATEDIFF(CURDATE(), invoice_date) AS aging,
        uc.company_id,
        uc.company 
      FROM grn g
      LEFT JOIN grn_items gi ON g.grn_id = gi.grn_id
      LEFT JOIN ${appSettings.masters_db}.vendors v ON g.vendor_id = v.vendor_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
      WHERE gi.item_category_id = ${req.id}
    `;

    let whereClause = ``;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    query += `${whereClause} GROUP BY g.grn_id ORDER BY g.invoice_date DESC`;

    // Updated: Group by g.inv_no instead of grn_id
    const paymentQuery = `
      SELECT 
        g.inv_no AS invoiceNo,
        SUM(g.payment) AS totalPayment
      FROM grn g
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
      WHERE g.inv_no IS NOT NULL ${whereClause}
      GROUP BY g.inv_no
    `;

    const info = await manager.query(query);
    const paymentRes = await manager.query(paymentQuery);

    // Create a map of invoiceNo → totalPayment
    const paymentMap = new Map<string, number>();
    for (const row of paymentRes) {
      paymentMap.set(row.invoiceNo, Number(row.totalPayment ?? 0));
    }

    // Map over info and inject correct payment and overdue
    const data = info.map((row: any) => {
      const invoiceNo = row.invoiceNo;
      const totalAmount = Number(row.totalPayables ?? 0);
      const paidAmount = paymentMap.get(invoiceNo) ?? 0;

      return {
        ...row,
        paidAmount,
        overdue: totalAmount - paidAmount
      };
    });

    if (data.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved', data);
    } else {
      return new CommonResponse(false, 0, 'No data found');
    }
  } catch (err) {
    throw err;
  }
}

  async getOverDuePackingRanges(req: PayablesDashboardReq): Promise<CommonResponse> {
    const manager = getManager();
  
    try {
      let query = `
        SELECT 
        g.inv_no AS invoiceNumber,
          g.grn_id,
          DATE_FORMAT(invoice_date, '%Y-%m-%d') AS invoiceDate,
         (SUM(tot_amount)-SUM(taxable_amount*0.001)) AS totalAmount,
          DATEDIFF('${req.toDate}', invoice_date) AS aging,
          g.unit_id,uc.company_id,uc.company
        FROM grn g
        LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id
      `;
  
    let whereClause = ` WHERE 1=1 `;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    query += whereClause ;
  
      query += `
        GROUP BY g.inv_no
      `;

          let paymentQuery = `
SELECT g.inv_no AS invoiceNumber, SUM(g.payment) AS totalPayment
      FROM grn g
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id 
      ${whereClause} GROUP BY g.inv_no
    `;
    const info = await manager.query(query);
    const paymentRes = await manager.query(paymentQuery);
  
        const paymentMap = new Map<string, number>();
    for (const row of paymentRes) {
      paymentMap.set(row.invoiceNumber, Number(row.totalPayment ?? 0));
    }
        const response = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      const payment = paymentMap.get(row.invoiceNumber) || 0;
      const overdue = totalAmount - payment;

      return {
        ...row,
        payment,
        overdue
      };
    });
      if (response.length > 0) {
        const fromDateObj = new Date(req.fromDate);
        const toDateObj = new Date(req.toDate);
  
        const formatDate = (date: Date) => date.toISOString().split('T')[0];
        const addDays = (date: Date, days: number) => {
          const result = new Date(date);
          result.setDate(result.getDate() + days);
          return result;
        };
  
        const getClippedRange = (start: Date, end: Date) => {
          const clippedStart = start < fromDateObj ? fromDateObj : start;
          const clippedEnd = end > toDateObj ? toDateObj : end;
          return clippedStart <= clippedEnd ? [clippedStart, clippedEnd] : [null, null];
        };
  
        const rawRanges = [
          { range: '0-15', startOffset: -14, endOffset: 0 },
          { range: '15-30', startOffset: -29, endOffset: -15 },
          { range: '30-45', startOffset: -44, endOffset: -30 },
          { range: '45-60', startOffset: -59, endOffset: -45 },
          { range: '60-80', startOffset: -79, endOffset: -60 },
          { range: 'above 80', startOffset: -10000, endOffset: -80 }
        ];
  
        const ranges = rawRanges.map(r => {
          const rawStart = addDays(toDateObj, r.startOffset);
          const rawEnd = addDays(toDateObj, r.endOffset);
          const [start, end] = getClippedRange(rawStart, rawEnd);
          return {
            range: r.range,
            from: start ? formatDate(start) : null,
            to: end ? formatDate(end) : null,
            sum: 0
          };
        });
  
        for (const res of response) {
          const invoiceDate = res.invoiceDate;
          const dueAmount = Number(res.overdue);
  
          for (const r of ranges) {
            if (r.from && r.to && invoiceDate >= r.from && invoiceDate <= r.to) {
              r.sum += dueAmount;
              break;
            }
          }
        }
  
        const result = ranges.map(r => ({
          range: r.range,
          sum: r.sum,
          fromDate: r.sum > 0 ? r.from : null,
          toDate: r.sum > 0 ? r.to : null
        }));
  
        return new CommonResponse(true, 1, 'Data retrieved successfully', result);
      } else {
        return new CommonResponse(false, 0, 'No data found');
      }
    } catch (err) {
      console.error('Error in getOverDuePackingRanges:', err);
      throw err;
    }
  }


  async getOverDuePackinginvoices(req: PayablesDashboardReq): Promise<CommonResponse> {
    const manager = getManager();
    try {
      let query = `
        SELECT 
          g.grn_id,
          g.inv_no AS invoiceNumber,
          Date(invoice_date) AS invoiceDate,
          (SUM(tot_amount)-SUM(taxable_amount*0.001)) AS totalAmount,
          DATEDIFF(CURDATE(), invoice_date) AS aging,
          g.unit_id,
          g.vendor_id,
          v.vendor_name AS vendorName,SUM(gi.taxable_amount*0.001) AS taxableAmount,uc.company_id,uc.company
        FROM grn g
        LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
        LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = g.vendor_id
        LEFT JOIN ${appSettings.masters_db}.unitcodes uc on uc.unit_code_id=g.unit_id
      `;
  
 let whereClause = ` WHERE 1 = 1`;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    query += whereClause + ` GROUP BY g.inv_no ORDER BY invoice_date`;
  
 const paymentQuery = `
      SELECT 
        g.inv_no AS invoiceNumber,
        SUM(g.payment) AS totalPayment
      FROM grn g
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
      ${whereClause}
      GROUP BY g.inv_no
    `;

    const info = await manager.query(query);
    const paymentRes = await manager.query(paymentQuery);

    // Convert payment result to map by invoiceNumber
    const paymentMap = new Map<string, number>();
    for (const row of paymentRes) {
      paymentMap.set(row.invoiceNumber, Number(row.totalPayment ?? 0));
    }

    // Merge payment and overdue into each row based on invoiceNumber
    const response = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      const payment = paymentMap.get(row.invoiceNumber) || 0;
      const overdue = totalAmount - payment;

      return {
        ...row,
        payment,
        overdue
      };
    });      return new CommonResponse(true, 1, 'Data retrieved successfully', response);
    } catch (err) {
      throw err;
    }
  }
async getTotalPackingPaidsReport(req?: PayablesDashboardReq): Promise<CommonResponse> {
  const manager = getManager();
  try {
    let getQry = `
      SELECT 
        g.grn_id,
        invoice_date AS invoiceDate,
        g.inv_no AS invoiceNumber,
        (SUM(tot_amount) - SUM(gi.taxable_amount * 0.001)) AS totalAmount,
        v.vendor_name AS vendorName,
        uc.company_id,
        uc.company
      FROM grn g
      LEFT JOIN grn_items gi ON gi.grn_id = g.grn_id
      LEFT JOIN ${appSettings.masters_db}.vendors v ON v.vendor_id = g.vendor_id
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
    `;

    let whereClause = ` WHERE g.payment IS NOT NULL`;
    if (req.fromDate && req.toDate) {
      whereClause += ` AND DATE(invoice_date) BETWEEN '${req.fromDate}' AND '${req.toDate}'`;
    }
    if (req.unitId) {
      whereClause += ` AND g.unit_id = '${req.unitId}'`;
    }
    if (req.vendorId) {
      whereClause += ` AND g.vendor_id = '${req.vendorId}'`;
    }
    if (req.company) {
      whereClause += ` AND uc.company_id = '${req.company}'`;
    }

    getQry += whereClause + ` GROUP BY g.inv_no ORDER BY invoice_date`;

    const paymentQuery = `
      SELECT 
        g.inv_no AS invoiceNumber,
        SUM(g.payment) AS totalPayment
      FROM grn g
      LEFT JOIN ${appSettings.masters_db}.unitcodes uc ON uc.unit_code_id = g.unit_id
      ${whereClause}
      GROUP BY g.inv_no
    `;

    const info = await manager.query(getQry);
    const paymentRes = await manager.query(paymentQuery);

    // Convert payment result to map by invoiceNumber
    const paymentMap = new Map<string, number>();
    for (const row of paymentRes) {
      paymentMap.set(row.invoiceNumber, Number(row.totalPayment ?? 0));
    }

    // Merge payment and overdue into each row based on invoiceNumber
    const result = info.map((row: any) => {
      const totalAmount = Number(row.totalAmount ?? 0);
      const payment = paymentMap.get(row.invoiceNumber) || 0;
      const overdue = totalAmount - payment;

      return {
        ...row,
        payment,
        overdue
      };
    });

    if (result.length > 0) {
      return new CommonResponse(true, 1, 'Data retrieved', result);
    } else {
      return new CommonResponse(false, 0, 'No data found');
    }
  } catch (err) {
    throw err;
  }
}


  async getUnitsForCeoDashboard(req?:PayablesDashboardReq):Promise<CommonResponse>{
    const manager = getManager()
    try{
      let getQry = `
      SELECT unit_code_id AS unitCodeId,unit_name AS unitName,plant_code AS plantCode FROM erpx_dev_masters.unitcodes
WHERE plant_type="PLANT" and is_active =1
    `;
    
      const info = await manager.query(getQry)

      if(info.length > 0){
        return new CommonResponse(true,1,'Data retrieved',info)
      }else{
        return new CommonResponse(false,0,'No data found')
      }
    }catch(err){
      throw err
    }
  }

}




